(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["black-friday-countdown"] && !Shopify.designMode) return;
  try {
    
/**
 * 以明确的 ISO 8601 时区计算剩余时间，拒绝无效日期，避免不同访客看到不同截止时间。
 * @param {string} deadline 带时区的截止时间，支持秒级精度。
 * @param {number} now 当前 Unix 毫秒数，必须是有限数值。
 * @returns {Object} 包含 status、days、hours、minutes、seconds 的非负倒计时状态。
 */
function getCountdownState(deadline, now = Date.now()) {
  const zero = { days: 0, hours: 0, minutes: 0, seconds: 0 };
  const match = typeof deadline === 'string' && deadline.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(Z|[+-]\d{2}:\d{2})$/);
  if (!match || !Number.isFinite(now)) return { status: 'invalid', ...zero };
  const [, year, month, day, hour, minute, second = '0', timezone] = match;
  const monthDays = new Date(Date.UTC(Number(year), Number(month), 0)).getUTCDate();
  const invalidOffset = timezone !== 'Z' && (Number(timezone.slice(1, 3)) > 14 || Number(timezone.slice(4)) > 59 || (Number(timezone.slice(1, 3)) === 14 && Number(timezone.slice(4)) !== 0));
  const endTime = Date.parse(deadline);
  if (Number(month) < 1 || Number(month) > 12 || Number(day) < 1 || Number(day) > monthDays || Number(hour) > 23 || Number(minute) > 59 || Number(second) > 59 || invalidOffset || !Number.isFinite(endTime)) {
    return { status: 'invalid', ...zero };
  }
  const remainingSeconds = Math.max(0, Math.ceil((endTime - now) / 1000));
  if (remainingSeconds === 0) return { status: 'expired', ...zero };
  return {
    status: 'running',
    days: Math.floor(remainingSeconds / 86400),
    hours: Math.floor(remainingSeconds / 3600) % 24,
    minutes: Math.floor(remainingSeconds / 60) % 60,
    seconds: remainingSeconds % 60,
  };
}

// 自定义元素自动支持主题编辑器的模块重载，卸载时释放定时器和事件监听。
if (typeof customElements !== 'undefined' && !customElements.get('black-friday-countdown')) {
  class BlackFridayCountdown extends HTMLElement {
    #interval = null;
    #events = null;

    connectedCallback() {
      this.#events?.abort();
      this.#events = new AbortController();
      this.#update();
      document.addEventListener('visibilitychange', () => this.#synchronize(), { signal: this.#events.signal });
      this.#synchronize();
    }

    disconnectedCallback() {
      clearInterval(this.#interval);
      this.#events?.abort();
    }

    #synchronize() {
      clearInterval(this.#interval);
      this.#update();
      if (!document.hidden && this.dataset.countdownState === 'running') {
        this.#interval = setInterval(() => this.#update(), 1000);
      }
    }

    #update() {
      const state = getCountdownState(this.dataset.deadline);
      if (state.status === 'invalid' && this.dataset.countdownState !== 'invalid') {
        console.warn('[黑五倒计时] 截止时间无效，请使用包含时区的 ISO 8601 时间。', { sectionId: this.id });
      }
      this.dataset.countdownState = state.status;
      for (const element of this.querySelectorAll('[data-time-value]')) {
        const value = state[element.dataset.timeValue];
        if (typeof value === 'number') element.textContent = String(value).padStart(2, '0');
      }
      const timer = this.querySelector('[data-countdown-timer]');
      if (timer) timer.hidden = state.status !== 'running';
      for (const message of this.querySelectorAll('[data-countdown-message]')) {
        message.hidden = message.dataset.countdownMessage !== state.status;
      }
      if (state.status !== 'running') clearInterval(this.#interval);
    }
  }
  customElements.define('black-friday-countdown', BlackFridayCountdown);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["black-friday-group-buy-product"] && !Shopify.designMode) return;
  try {
    
  /** 管理加载与公开团展示；订单、身份及支付校验仍由官方 App 处理。 */
  class BlackFridayGroupProduct extends HTMLElement {
    static appWaitMilliseconds = 15000;
    // 仅依赖官方组件已渲染的节点，不读取 Alpine 状态或调用 App 私有接口。
    static publicGroupSelectors = Object.freeze({
      panel: '.processing-groups-panel',
      row: '.processing-group-item',
      progress: '.paid-count',
      title: '[data-bf-public-title]'
    });
    #appContainer;
    #appObserver;
    #appTimeout;
    #reportedUnavailable = false;
    #reportedProgressFormat = false;

    /** 捕获阶段重新校验人数，拦截异步更新间隙中已经失效的公开团点击。 */
    #handlePublicGroupClick = (event) => {
      if (!(event.target instanceof Element)) return;
      const row = event.target.closest(BlackFridayGroupProduct.publicGroupSelectors.row);
      if (!row || !this.#appContainer?.contains(row) || this.#isJoinablePublicGroup(row)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.#filterPublicGroups();
    };

    connectedCallback() {
      // 包含多个多属性的商品属于旧套装结构，阻止其误入每单单台的正式流程。
      if (this.dataset.purchasable !== 'true') { this.dataset.state = 'unavailable'; return; }
      this.#showStatus('loading', this.dataset.loadingText);
      this.#appContainer = this.querySelector('[data-group-app]');
      if (this.#appContainer) {
        this.#appContainer.addEventListener('click', this.#handlePublicGroupClick, true);
        this.#appObserver = new MutationObserver(() => this.#refreshAppState());
        this.#appObserver.observe(this.#appContainer, { childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['class','style','hidden','disabled'] });
      }
      this.#appTimeout = window.setTimeout(() => {
        if (!this.#refreshAppState()) {
          this.#showStatus('unavailable', this.dataset.unavailableText);
          if (!this.#reportedUnavailable) {
            console.warn('[黑五拼团] 官方购买组件尚未可用，请检查 App 安装、活动及商品配置。');
            this.#reportedUnavailable = true;
          }
        }
      }, BlackFridayGroupProduct.appWaitMilliseconds);
      this.#refreshAppState();
    }

    disconnectedCallback() {
      this.#appObserver?.disconnect();
      window.clearTimeout(this.#appTimeout);
      this.#appContainer?.removeEventListener('click', this.#handlePublicGroupClick, true);
      this.#appContainer = undefined;
    }

    /** 同一观察器同步公开列表和加载状态；主题自有属性更新不进入监听范围。 */
    #refreshAppState() {
      this.#filterPublicGroups();
      return this.#checkAppButton();
    }

    /**
     * 输入为官方 .paid-count 的人数比例，输出有效整数或 null。
     * 兼容本地化前后缀与全角数字；缺失、负数、小数、溢出及异常比例一律不展示。
     * 此数值只用于店面展示，不能替代 App 服务端的付款确认。
     */
    #readGroupProgress(row) {
      const progressNode = row.querySelector(BlackFridayGroupProduct.publicGroupSelectors.progress);
      const text = progressNode?.textContent?.normalize('NFKC').trim() || '';
      const match = text.match(/^([^\d]*?)(\d+)\s*\/\s*(\d+)([^\d]*)$/u);
      if (match && !/[+\-−.,\/]/u.test(match[1] + match[4])) {
        const paidMembers = Number(match[2]);
        const requiredMembers = Number(match[3]);
        if (Number.isSafeInteger(paidMembers) && Number.isSafeInteger(requiredMembers) && requiredMembers >= 2 && paidMembers <= requiredMembers) {
          return { paidMembers, requiredMembers };
        }
      }
      if (!this.#reportedProgressFormat) {
        console.warn('[黑五拼团] 公开团人数节点缺失或格式异常，已停止展示相关参团入口。');
        this.#reportedProgressFormat = true;
      }
      return null;
    }

    /** 公开参团入口必须至少有一名已付款成员，并且仍有空位。 */
    #isJoinablePublicGroup(row) {
      const progress = this.#readGroupProgress(row);
      return Boolean(progress && progress.paidMembers > 0 && progress.paidMembers < progress.requiredMembers);
    }

    /** 根据官方已显示的付款人数过滤列表，不改写成员数、团状态或原按钮事件。 */
    #filterPublicGroups() {
      const selectors = BlackFridayGroupProduct.publicGroupSelectors;
      this.#appContainer?.querySelectorAll(selectors.panel).forEach((panel) => {
        let visibleGroups = 0;
        panel.querySelectorAll(selectors.row).forEach((row) => {
          const joinable = this.#isJoinablePublicGroup(row);
          const state = joinable ? 'joinable' : 'unavailable';
          if (row.dataset.bfGroupState !== state) row.dataset.bfGroupState = state;
          if (joinable) visibleGroups += 1;
        });
        const panelState = visibleGroups > 0 ? 'ready' : 'empty';
        if (panel.dataset.bfPublicState !== panelState) panel.dataset.bfPublicState = panelState;
        if (visibleGroups > 0) this.#updatePublicGroupsTitle(panel, visibleGroups);
      });
    }

    /** 独立维护过滤后的标题，避免原 App 总团数把未付款记录也算进去。 */
    #updatePublicGroupsTitle(panel, visibleGroups) {
      const label = this.dataset.publicGroupsTitle?.replaceAll('[count]', String(visibleGroups));
      if (!label) return;
      let title = panel.querySelector(BlackFridayGroupProduct.publicGroupSelectors.title);
      if (!title) {
        title = document.createElement('p');
        title.className = 'bf-group__public-title';
        title.setAttribute('data-bf-public-title', '');
        panel.prepend(title);
      }
      // 只有值变化才写入，避免文本更新再次触发自身观察器。
      if (title.textContent !== label) title.textContent = label;
    }

    /** 只检查实际渲染的官方按钮，不读取 Alpine 内部状态。 */
    #checkAppButton() {
      const button = this.querySelector('[data-group-app] .fh-group-buy-btn button');
      if (!button || !button.textContent.trim() || button.disabled || button.getClientRects().length === 0) return false;
      window.clearTimeout(this.#appTimeout);
      // 第三方区块可能把后续节点包入自身；幂等更新避免观察器重复触发自身。
      if (this.dataset.state !== 'ready') this.dataset.state = 'ready';
      const status = this.querySelector('[data-group-status]');
      if (status && !status.hidden) status.hidden = true;
      return true;
    }

    /** 加载与失败状态共用可访问的提示区，避免悄悄回退到普通购买。 */
    #showStatus(state, message) {
      this.dataset.state = state;
      const status = this.querySelector('[data-group-status]');
      if (!status) return;
      status.hidden = false;
      status.textContent = message || this.dataset.unavailableText || '';
    }
  }
  if (!customElements.get('black-friday-group-product')) customElements.define('black-friday-group-product', BlackFridayGroupProduct);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["black-friday-sleep"] && !Shopify.designMode) return;
  try {
    
(() => {
  /**
   * 监听图片加载；原生图片失败时仅尝试一次主题资源，彻底失败后明确显示提示。
   * @param {HTMLElement} root 模块根节点
   * @returns {void}
   */
  const initializeSleepImages = (root) => {
    for (const image of root.querySelectorAll('.bf-sleep-slider__image')) {
      if (image.dataset.sleepImageReady === 'true') continue;
      image.dataset.sleepImageReady = 'true';
      const frame = image.closest('.bf-sleep-slider__image-frame');
      const errorLabel = frame?.querySelector('[data-sleep-image-error]');
      const handleError = () => {
        const fallback = frame?.dataset.sleepFallbackSrc;
        if (fallback && image.dataset.sleepFallbackTried !== 'true') {
          image.dataset.sleepFallbackTried = 'true';
          image.removeAttribute('srcset');
          image.src = fallback;
          return;
        }
        image.hidden = true;
        frame?.classList.add('bf-sleep-slider__image-frame--failed');
        if (errorLabel) errorLabel.hidden = false;
        console.warn('[Sleep slider] 图片加载失败，请检查后台所选主图片或主题图片资源。');
      };
      image.addEventListener('error', handleError);
      image.addEventListener('load', () => {
        image.hidden = false;
        frame?.classList.remove('bf-sleep-slider__image-frame--failed');
        if (errorLabel) errorLabel.hidden = true;
      });
      if (image.complete && image.naturalWidth === 0) handleError();
    }
  };

  /**
   * 初始化单个睡眠故事轮播，并集中处理键盘、触摸、自动播放和无障碍状态。
   * @param {HTMLElement} root 轮播根节点
   * @returns {void}
   */
  const initializeSleepSlider = (root) => {
    if (!root) return;
    initializeSleepImages(root);
    if (root.dataset.sleepSliderReady === 'true') return;

    const track = root.querySelector('[data-sleep-track]');
    const slides = Array.from(root.querySelectorAll('[data-sleep-slide]'));
    const liveRegion = root.querySelector('[data-sleep-live]');
    const viewport = root.querySelector('.bf-sleep-slider__viewport');

    if (!track || slides.length === 0 || !viewport) return;

    root.dataset.sleepSliderReady = 'true';
    root.classList.add('bf-sleep-slider--js');

    const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const autoplayEnabled = root.dataset.autoplay === 'true';
    const autoplayDelay = Math.max(Number(root.dataset.autoplayDelay) || 7000, 5000);
    let activeIndex = 0;
    let autoplayTimer = null;
    let pointerStartX = null;
    let pointerStartY = null;
    let isHovered = false;
    let isFocused = false;
    let isManuallyPaused = false;
    const playbackButton = root.querySelector('[data-sleep-playback]');

    /**
     * 更新当前卡片、离屏焦点和屏幕阅读器状态。
     * @param {number} nextIndex 目标索引
     * @returns {void}
     */
    const updateActiveSlide = (nextIndex) => {
      if (!Number.isInteger(nextIndex)) return;
      activeIndex = (nextIndex + slides.length) % slides.length;
      // 切换前将离屏内容中的焦点移回可见区域，避免焦点落在隐藏按钮中。
      if (slides.some((slide, index) => index !== activeIndex && slide.contains(document.activeElement))) {
        viewport.focus({ preventScroll: true });
      }
      track.style.transform = 'translate3d(-' + (activeIndex * 100) + '%, 0, 0)';

      for (const [index, slide] of slides.entries()) {
        const isActive = index === activeIndex;
        slide.setAttribute('aria-hidden', String(!isActive));
        slide.inert = !isActive;
      }

      const activeTitle = slides[activeIndex].querySelector('.bf-sleep-slider__heading')?.textContent?.trim();
      if (liveRegion && activeTitle) {
        liveRegion.textContent = 'Slide ' + (activeIndex + 1) + ' of ' + slides.length + ': ' + activeTitle;
      }
    };

    /**
     * 停止自动播放，供悬停、聚焦和手动交互调用。
     * @returns {void}
     */
    const pauseAutoplay = () => {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    };

    /**
     * 在支持自动播放且未开启减少动画时启动轮播。
     * @returns {void}
     */
    const startAutoplay = () => {
      pauseAutoplay();
      if (!autoplayEnabled || reduceMotionQuery.matches || slides.length < 2 || isHovered || isFocused || isManuallyPaused || document.hidden) return;
      autoplayTimer = window.setInterval(() => updateActiveSlide(activeIndex + 1), autoplayDelay);
    };

    for (const button of root.querySelectorAll('[data-sleep-prev]')) {
      button.addEventListener('click', () => {
        updateActiveSlide(activeIndex - 1);
        startAutoplay();
      });
    }

    for (const button of root.querySelectorAll('[data-sleep-next]')) {
      button.addEventListener('click', () => {
        updateActiveSlide(activeIndex + 1);
        startAutoplay();
      });
    }

    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        updateActiveSlide(activeIndex - 1);
        startAutoplay();
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        updateActiveSlide(activeIndex + 1);
        startAutoplay();
      }
    });

    viewport.addEventListener('pointerdown', (event) => {
      pointerStartX = event.clientX;
      pointerStartY = event.clientY;
      pauseAutoplay();
    });

    viewport.addEventListener('pointerup', (event) => {
      if (pointerStartX === null || pointerStartY === null) return;
      const deltaX = event.clientX - pointerStartX;
      const deltaY = event.clientY - pointerStartY;
      pointerStartX = null;
      pointerStartY = null;
      if (Math.abs(deltaX) > 44 && Math.abs(deltaX) > Math.abs(deltaY)) {
        updateActiveSlide(deltaX < 0 ? activeIndex + 1 : activeIndex - 1);
      }
      startAutoplay();
    });

    viewport.addEventListener('pointercancel', () => {
      pointerStartX = null;
      pointerStartY = null;
      startAutoplay();
    });

    root.addEventListener('mouseenter', () => { isHovered = true; pauseAutoplay(); });
    root.addEventListener('mouseleave', () => { isHovered = false; startAutoplay(); });
    root.addEventListener('focusin', () => { isFocused = true; pauseAutoplay(); });
    root.addEventListener('focusout', (event) => {
      isFocused = root.contains(event.relatedTarget);
      if (!isFocused) startAutoplay();
    });

    playbackButton?.addEventListener('click', () => {
      isManuallyPaused = !isManuallyPaused;
      playbackButton.setAttribute('aria-pressed', String(isManuallyPaused));
      const label = root.querySelector(isManuallyPaused ? '[data-sleep-play-label]' : '[data-sleep-pause-label]');
      if (label) playbackButton.textContent = label.content.textContent.trim();
      startAutoplay();
    });
    // 后台编辑器选中卡片时直接显示该卡片，并在模块卸载时清理全局监听和计时器。
    root.addEventListener('shopify:block:select', (event) => {
      const selectedSlide = event.target.closest('[data-sleep-slide]');
      if (!selectedSlide) return;
      updateActiveSlide(slides.indexOf(selectedSlide));
      isManuallyPaused = true;
      pauseAutoplay();
    });
    document.addEventListener('visibilitychange', startAutoplay);
    root.sleepSliderCleanup = () => {
      pauseAutoplay();
      document.removeEventListener('visibilitychange', startAutoplay);
      reduceMotionQuery.removeEventListener?.('change', startAutoplay);
    };
    reduceMotionQuery.addEventListener?.('change', startAutoplay);
    updateActiveSlide(0);
    startAutoplay();
  };

  const initializeAllSleepSliders = () => {
    for (const slider of document.querySelectorAll('[data-sleep-slider]')) {
      initializeSleepSlider(slider);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAllSleepSliders, { once: true });
  } else {
    initializeAllSleepSliders();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeSleepSlider(event.target.querySelector?.('[data-sleep-slider]'));
  });
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelector?.('[data-sleep-slider]')?.sleepSliderCleanup?.();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-editorial-comparison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-editorial-tabs]').forEach((root) => {
      const tabs = Array.from(root.querySelectorAll('[data-editorial-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-editorial-panel]'));
      const activate = (index) => {
        tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === index;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel, panelIndex) => { panel.hidden = panelIndex !== index; });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          const nextIndex = event.key === 'ArrowRight' ? (index + 1) % tabs.length : (index - 1 + tabs.length) % tabs.length;
          activate(nextIndex);
          tabs[nextIndex].focus();
        });
      });
      activate(0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gel-pack-experience"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gel-pack-accordion')) {
    class GelPackAccordion extends HTMLElement {
      #controller;

      connectedCallback() {
        // 主题编辑器可能重新挂载同一个元素，每次连接时重建监听控制器。
        this.#controller?.abort();
        this.#controller = new AbortController();
        this.addEventListener('toggle', this.#handleToggle, {
          capture: true,
          signal: this.#controller.signal,
        });
      }

      disconnectedCallback() {
        this.#controller?.abort();
      }

      #handleToggle = (event) => {
        const openedItem = event.target;
        if (!(openedItem instanceof HTMLDetailsElement) || !openedItem.open) return;

        for (const item of this.querySelectorAll('details[open]')) {
          if (item !== openedItem) item.open = false;
        }
      };
    }

    customElements.define('gel-pack-accordion', GelPackAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-vail-card-carousel"] && !Shopify.designMode) return;
  try {
    
  class IndexVailCardCarousel extends HTMLElement {
    #swiperInstance = null;
    #eventController = null;
    #swiperRetryTimer = null;
    #swiperLoadAttempts = 0;
    #autoplayEnabled = false;

    connectedCallback() {
      this.#eventController?.abort();
      this.#eventController = new AbortController();
      this.#swiperLoadAttempts = 0;
      this.addEventListener('click', this.#handleVideoControl, { signal: this.#eventController.signal });
      this.addEventListener('focusin', this.#pauseAutoplay, { signal: this.#eventController.signal });
      this.addEventListener('focusout', this.#resumeAutoplay, { signal: this.#eventController.signal });
      this.#initializeCarousel();
    }

    disconnectedCallback() {
      this.#eventController?.abort();
      this.#eventController = null;
      window.clearTimeout(this.#swiperRetryTimer);
      this.#swiperRetryTimer = null;
      this.#destroyCarousel();
    }

    #initializeCarousel() {
      const viewport = this.querySelector('[data-carousel-viewport]');
      const scrollbar = this.querySelector('[data-carousel-scrollbar]');
      if (!viewport || !scrollbar) {
        this.dataset.carouselState = 'invalid';
        console.warn('Vail 卡片轮播缺少必要的容器或滚动条。');
        return;
      }

      if (typeof window.Swiper !== 'function') {
        // 主题公共脚本可能晚于 section 执行，有限重试后降级为原生横向滚动。
        this.#scheduleSwiperRetry();
        return;
      }

      this.#destroyCarousel();
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const desktopItems = this.#readNumberSetting('desktopItems', 3.5, 1, 6);
      const mobileItems = this.#readNumberSetting('mobileItems', 1.2, 1, 4);
      const autoplayDelay = this.#readNumberSetting('autoplaySpeed', 3, 1, 10) * 1000;
      const cardGap = this.#readCssPixelValue('--vail-card-gap', 24, 8, 48);
      this.#autoplayEnabled = this.dataset.autoplayEnabled === 'true' && !reducedMotion;
      delete this.dataset.carouselState;

      try {
        this.#swiperInstance = new window.Swiper(viewport, {
          slidesPerView: mobileItems,
          spaceBetween: cardGap,
          speed: reducedMotion ? 0 : 300,
          freeMode: true,
          grabCursor: true,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          autoplay: this.#autoplayEnabled
            ? { delay: autoplayDelay, disableOnInteraction: false, pauseOnMouseEnter: true }
            : false,
          scrollbar: { el: scrollbar, draggable: true },
          breakpoints: {
            768: { slidesPerView: desktopItems, spaceBetween: cardGap }
          }
        });
      } catch (error) {
        this.dataset.carouselState = 'fallback';
        console.error('Vail 卡片轮播初始化失败，已切换为横向滚动。', error);
      }
    }

    #scheduleSwiperRetry() {
      const maximumAttempts = 20;
      if (this.#swiperLoadAttempts >= maximumAttempts) {
        this.dataset.carouselState = 'fallback';
        console.warn('Swiper 未加载，Vail 卡片轮播已切换为横向滚动。');
        return;
      }

      this.dataset.carouselState = 'pending';
      this.#swiperLoadAttempts += 1;
      this.#swiperRetryTimer = window.setTimeout(() => this.#initializeCarousel(), 200);
    }

    #destroyCarousel() {
      if (!this.#swiperInstance) return;
      this.#swiperInstance.destroy(true, true);
      this.#swiperInstance = null;
    }

    #readNumberSetting(datasetKey, fallbackValue, minimumValue, maximumValue) {
      const parsedValue = Number(this.dataset[datasetKey]);
      if (!Number.isFinite(parsedValue)) return fallbackValue;
      return Math.min(maximumValue, Math.max(minimumValue, parsedValue));
    }

    #readCssPixelValue(propertyName, fallbackValue, minimumValue, maximumValue) {
      const propertyValue = window.getComputedStyle(this).getPropertyValue(propertyName);
      const parsedValue = Number.parseFloat(propertyValue);
      if (!Number.isFinite(parsedValue)) return fallbackValue;
      return Math.min(maximumValue, Math.max(minimumValue, parsedValue));
    }

    #handleVideoControl = async (event) => {
      const controlButton = event.target.closest('[data-video-control]');
      const clickedVideo = event.target.closest('video');
      const controlTarget = controlButton || clickedVideo;
      if (!controlTarget || !this.contains(controlTarget)) return;
      event.preventDefault();
      event.stopPropagation();

      const mediaContainer = controlTarget.closest('.index-vail-card-carousel__media');
      const videoElement = clickedVideo || mediaContainer?.querySelector('video');
      const mediaControlButton = controlButton || mediaContainer?.querySelector('[data-video-control]');
      if (!videoElement) {
        console.warn('播放按钮未找到对应的视频元素。');
        return;
      }

      if (!videoElement.paused) {
        videoElement.pause();
        mediaContainer.classList.remove('has-started');
        mediaControlButton?.setAttribute('aria-label', this.dataset.playLabel || 'Play video');
        return;
      }

      try {
        videoElement.muted = false;
        await videoElement.play();
        // 仅在浏览器确认播放成功后隐藏封面，播放失败时继续保留封面。
        mediaContainer.classList.add('has-started');
        mediaControlButton?.setAttribute('aria-label', this.dataset.pauseLabel || 'Pause video');
      } catch (error) {
        videoElement.muted = true;
        mediaControlButton?.setAttribute('aria-label', this.dataset.playLabel || 'Play video');
        console.error('Vail 卡片视频播放失败。', error);
      }
    };

    #pauseAutoplay = () => {
      this.#swiperInstance?.autoplay?.stop();
    };

    #resumeAutoplay = (event) => {
      if (this.contains(event.relatedTarget) || !this.#autoplayEnabled) return;
      this.#swiperInstance?.autoplay?.start();
    };
  }

  if (!customElements.get('index-vail-card-carousel')) {
    customElements.define('index-vail-card-carousel', IndexVailCardCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luna-plus-comparison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.lunaFamilyComparisonControlsReady) return;
    window.lunaFamilyComparisonControlsReady = true;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobileViewport = window.matchMedia('(max-width: 800px)');

    const stopAutoplay = (carousel) => {
      if (!carousel.lunaComparisonTimer) return;
      window.clearInterval(carousel.lunaComparisonTimer);
      carousel.lunaComparisonTimer = null;
    };

    const showSlide = (carousel, requestedIndex) => {
      const slides = Array.from(carousel.querySelectorAll('[data-luna-comparison-slide]'));
      if (slides.length === 0) return;

      const activeIndex = (requestedIndex + slides.length) % slides.length;
      carousel.dataset.activeIndex = String(activeIndex);
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });
    };

    const startAutoplay = (carousel) => {
      stopAutoplay(carousel);
      if (!mobileViewport.matches || reducedMotion.matches || carousel.matches(':hover') || carousel.contains(document.activeElement)) return;

      carousel.lunaComparisonTimer = window.setInterval(() => {
        const currentIndex = Number(carousel.dataset.activeIndex || 0);
        showSlide(carousel, currentIndex + 1);
      }, 6000);
    };

    const moveSlide = (carousel, direction) => {
      const currentIndex = Number(carousel.dataset.activeIndex || 0);
      showSlide(carousel, currentIndex + direction);
      startAutoplay(carousel);
    };

    const initializeCarousel = (carousel) => {
      if (carousel.dataset.carouselReady === 'true') return;
      carousel.dataset.carouselReady = 'true';
      carousel.dataset.activeIndex = '0';
      showSlide(carousel, 0);

      carousel.querySelector('[data-luna-comparison-previous]')?.addEventListener('click', () => moveSlide(carousel, -1));
      carousel.querySelector('[data-luna-comparison-next]')?.addEventListener('click', () => moveSlide(carousel, 1));
      carousel.addEventListener('pointerenter', () => stopAutoplay(carousel));
      carousel.addEventListener('pointerleave', () => startAutoplay(carousel));
      carousel.addEventListener('focusin', () => stopAutoplay(carousel));
      carousel.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!carousel.contains(document.activeElement)) startAutoplay(carousel);
        }, 0);
      });

      startAutoplay(carousel);
    };

    const initializeCarousels = (root) => {
      if (root.matches?.('[data-luna-comparison-carousel]')) initializeCarousel(root);
      root.querySelectorAll?.('[data-luna-comparison-carousel]').forEach(initializeCarousel);
    };

    document.addEventListener('click', (event) => {
      const toggleButton = event.target.closest('[data-luna-comparison-toggle]');
      if (!toggleButton) return;

      const disclosure = toggleButton.closest('[data-luna-comparison-disclosure]');
      const label = toggleButton.querySelector('[data-luna-comparison-toggle-label]');
      if (!disclosure || !label) return;

      const expanded = toggleButton.getAttribute('aria-expanded') !== 'true';
      disclosure.classList.toggle('is-expanded', expanded);
      toggleButton.setAttribute('aria-expanded', String(expanded));
      label.textContent = expanded ? toggleButton.dataset.lessLabel : toggleButton.dataset.moreLabel;
    });

    document.addEventListener('shopify:section:load', (event) => initializeCarousels(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll?.('[data-luna-comparison-carousel]').forEach(stopAutoplay);
    });
    document.addEventListener('visibilitychange', () => {
      document.querySelectorAll('[data-luna-comparison-carousel]').forEach((carousel) => {
        if (document.hidden) stopAutoplay(carousel);
        else startAutoplay(carousel);
      });
    });
    reducedMotion.addEventListener('change', () => {
      document.querySelectorAll('[data-luna-comparison-carousel]').forEach(startAutoplay);
    });
    mobileViewport.addEventListener('change', () => {
      document.querySelectorAll('[data-luna-comparison-carousel]').forEach(startAutoplay);
    });

    initializeCarousels(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ocean-ritual"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ocean-ritual')) {
  class OceanRitual extends HTMLElement {
    // 主题编辑器重挂载时重新绑定，卸载时释放网络请求、监听器和下载资源。
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      this.requests = new Set();
      this.timers = new Set();
      this.objectUrls = new Set();
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.initializeExperience();
      this.initializeFilm();
      this.initializeSubscription();
      this.addEventListener('click', event => this.downloadFile(event), { signal: this.events.signal });
    }

    disconnectedCallback() {
      this.events?.abort();
      if (this.animationFrame) window.cancelAnimationFrame(this.animationFrame);
      if (this.progressAnimationFrame) window.cancelAnimationFrame(this.progressAnimationFrame);
      this.sceneObserver?.disconnect();
      for (const request of this.requests ?? []) request.abort();
      for (const timer of this.timers ?? []) window.clearTimeout(timer);
      for (const url of this.objectUrls ?? []) URL.revokeObjectURL(url);
    }

    /** 演示规则固定为 50–150 BPM；无效输入返回 null，不读取任何健康数据。 */
    getCircleIndex(value) {
      if (value === null || value === undefined || value === '') return null;
      const bpm = Number(value);
      if (!Number.isInteger(bpm) || bpm < 50 || bpm > 150) return null;
      return bpm < 80 ? 0 : bpm < 110 ? 1 : 2;
    }

    initializeFilm() {
      const film = this.querySelector('.ocean-ritual__video');
      const overlay = this.querySelector('[data-film-overlay]');
      if (!film || !overlay) return;
      film.addEventListener('play', () => {overlay.hidden = true;}, {signal:this.events.signal});
      film.addEventListener('ended', () => {overlay.hidden = false;}, {signal:this.events.signal});
    }

    initializeExperience() {
      const experience = this.querySelector('[data-experience]');
      if (!experience) return;
      const slider = experience.querySelector('[data-bpm-slider]');
      const button = experience.querySelector('[data-join-demo]');
      if (!slider || !button) return;
      this.initializeScene(experience);
      const update = () => this.updateExperience(experience, slider.value);
      slider.addEventListener('input', update, { signal: this.events.signal });
      button.addEventListener('click', () => {
        experience.dataset.joined = 'true';
        update();
      }, { signal: this.events.signal });
      update();
    }

    // 将分组名称、说明、选中圆圈和个人鱼标识统一同步到当前心率。
    updateExperience(experience, value) {
      const index = this.getCircleIndex(value);
      if (index === null) return;
      const names = experience.querySelectorAll('[data-circle-name-template]');
      const bodies = experience.querySelectorAll('[data-circle-body-template]');
      if (!names[index] || !bodies[index]) return;
      const name = names[index].content.textContent.trim();
      experience.querySelector('[data-bpm-output]').textContent = String(value);
      experience.querySelector('[data-circle-name]').textContent = name;
      experience.querySelector('[data-circle-description]').replaceChildren(bodies[index].content.cloneNode(true));
      if (this.sceneState) {
        this.sceneState.index = index;
        this.sceneState.joined = experience.dataset.joined === 'true';
        this.drawScene();
      }
      if (experience.dataset.joined !== 'true') return;
      const joined = experience.querySelector('[data-joined-template]').content.textContent.trim();
      experience.querySelector('[data-fish-status]').textContent = `${joined} · ${name}`;
    }

    // 设计稿中的 Canvas 是交互场景；原始位图保留作无脚本或绘图失败时的回退。
    initializeScene(experience) {
      const canvas = experience.querySelector('[data-ocean-scene]');
      const context = canvas?.getContext('2d');
      if (!context) return;
      const style = getComputedStyle(experience);
      this.sceneState = {experience, canvas, context, index:0, joined:false, paused:false, visible:true, elapsed:0,
        accent:style.getPropertyValue('--ocean-accent').trim(),
        labelColor:style.getPropertyValue('--ocean-label-color').trim(),
        labelSize:Math.max(12, parseFloat(style.getPropertyValue('--ocean-label-size')) * 1.6),
        labelWeight:style.getPropertyValue('--ocean-label-weight').trim(),
        fontFamily:style.fontFamily};
      this.drawScene();
      canvas.hidden = false;
      experience.querySelector('.ocean-ritual__circles-image').hidden = true;
      const toggle = experience.querySelector('[data-motion-toggle]');
      toggle.addEventListener('click', () => {
        this.sceneState.paused = !this.sceneState.paused;
        const template = experience.querySelector(this.sceneState.paused ? '[data-resume-template]' : '[data-pause-template]');
        toggle.textContent = template.content.textContent.trim();
        this.syncSceneAnimation();
      }, {signal:this.events.signal});
      const sync = () => {toggle.hidden = this.motionQuery.matches; this.syncSceneAnimation();};
      document.addEventListener('visibilitychange', sync, {signal:this.events.signal});
      this.motionQuery.addEventListener('change', sync, {signal:this.events.signal});
      this.sceneObserver = new IntersectionObserver(entries => {
        this.sceneState.visible = entries[0].isIntersecting;
        this.syncSceneAnimation();
      });
      this.sceneObserver.observe(canvas);
      sync();
    }

    // 页面离开视口、进入后台、用户暂停或系统要求减少动效时，停止动画帧。
    syncSceneAnimation() {
      if (this.animationFrame) window.cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
      const state = this.sceneState;
      if (!state || !state.visible || state.paused || this.motionQuery.matches || document.hidden) return;
      let previousTime = null;
      const animate = timestamp => {
        if (!this.isConnected) return;
        if (previousTime !== null) state.elapsed += Math.min(timestamp - previousTime, 50);
        previousTime = timestamp;
        this.drawScene();
        this.animationFrame = window.requestAnimationFrame(animate);
      };
      this.animationFrame = window.requestAnimationFrame(animate);
    }

    /** 以设计稿的 1280×800 坐标绘制三组鱼群；文字与强调色使用当前区块 CSS 变量。 */
    drawScene() {
      const state = this.sceneState;
      if (!state) return;
      const {context} = state;
      const background = context.createLinearGradient(0,0,0,800);
      background.addColorStop(0,'#0c606b'); background.addColorStop(1,'#02242b');
      context.fillStyle = background;
      context.fillRect(0,0,1280,800);
      const names = state.experience.querySelectorAll('[data-circle-name-template]');
      const time = state.elapsed / 1000;
      for (let group = 0; group < 3; group++) {
        const centerX = 250 + group * 390;
        context.beginPath(); context.arc(centerX,385,156,0,Math.PI*2);
        context.fillStyle = 'rgba(120,217,209,.06)'; context.fill();
        context.strokeStyle = group === state.index ? state.accent : 'rgba(244,241,231,.24)';
        context.lineWidth = group === state.index ? 3 : 1; context.stroke();
        context.textAlign = 'center'; context.fillStyle = state.labelColor;
        context.font = `${state.labelWeight} ${state.labelSize}px ${state.fontFamily}`;
        context.fillText(names[group]?.content.textContent.trim() || '',centerX,260,290);
        context.fillText(['50–79 BPM','80–109 BPM','110–150 BPM'][group],centerX,285,290);
        for (let fish = 0; fish < 11; fish++) {
          const phase = fish * 2.37;
          const x = centerX + Math.sin(phase + time * (.12 + group * .09)) * (70 + fish * 4);
          const y = 390 + Math.cos(phase * 1.4 + time * .2) * 58;
          this.drawFish(context,x,y,14 + fish % 4 * 4,fish % 3 ? '#00333c' : '#66989d',fish % 2 ? 1 : -1);
        }
      }
      const personalX = state.joined ? 250 + state.index * 390 + Math.sin(time) * 30 : 65;
      const personalY = state.joined ? 435 + Math.cos(time) * 12 : 655;
      this.drawFish(context,personalX,personalY,30,state.accent,1);
    }

    drawFish(context,x,y,size,color,direction) {
      context.save(); context.translate(x,y); context.scale(direction,1); context.fillStyle = color;
      context.beginPath(); context.moveTo(-size,0); context.quadraticCurveTo(0,-size*.56,size,0); context.quadraticCurveTo(0,size*.56,-size,0); context.fill();
      context.beginPath(); context.moveTo(-size,0); context.lineTo(-size*1.48,-size*.45); context.lineTo(-size*1.38,0); context.lineTo(-size*1.48,size*.45); context.closePath(); context.fill(); context.restore();
    }

    readSession(key) {
      try { return window.sessionStorage.getItem(key); }
      catch (error) { console.warn('海洋活动：无法读取会话。', error); return null; }
    }

    writeSession(key, value) {
      try { window.sessionStorage.setItem(key, String(value)); }
      catch (error) { console.warn('海洋活动：无法保存会话。', error); }
    }

    // 同一基数下仅计一次成功订阅；后台调整基数后使用新的展示起点。
    recordSubscription(state) {
      const signature = String(state.base);
      if (state.recordedBase === signature || this.readSession(`${state.key}:subscribed`) === signature) return Math.min(state.base + 1, Number.MAX_SAFE_INTEGER);
      this.writeSession(`${state.key}:subscribed`, signature);
      state.recordedBase = signature;
      return Math.min(state.base + 1, Number.MAX_SAFE_INTEGER);
    }

    initializeSubscription() {
      const section = this.querySelector('[data-subscription]');
      const form = section?.querySelector('form');
      if (!form) return;
      const rawBase = Number(section.dataset.base);
      const base = Number.isSafeInteger(rawBase) && rawBase >= 0 ? rawBase : 0;
      const state = {key: `ocean-interest:${section.dataset.countKey}`, base, count: base, busy: false};
      if (this.readSession(`${state.key}:subscribed`) === String(base) || form.querySelector('[data-server-success]')) {
        state.count = this.recordSubscription(state);
        this.showSuccess(section, false);
      }
      this.updateCount(section, state.count);
      form.addEventListener('submit', event => this.submitSubscription(event, section, state), {signal: this.events.signal});
    }

    updateCount(section, count, animate = false) {
      section.querySelector('[data-count]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en').format(count);
      const progress = section.querySelector('[data-count-progress]');
      const track = section.querySelector('[data-charge-track]');
      if (!progress || !track) return;
      const nextValue = Math.max(0, Math.min(count, progress.max));
      if (this.progressAnimationFrame) window.cancelAnimationFrame(this.progressAnimationFrame);
      this.progressAnimationFrame = null;
      track.classList.remove('is-charging');
      if (!animate || this.motionQuery.matches) {
        progress.value = nextValue;
        return;
      }
      // 成功响应后才从旧进度向新进度充能；基数和内部基准仍可在后台调整。
      const previousValue = Number(progress.value) || 0;
      const durationMs = 900;
      const startTime = performance.now();
      void track.offsetWidth;
      track.classList.add('is-charging');
      const advance = timestamp => {
        const elapsedRatio = this.motionQuery.matches ? 1 : Math.min(1, Math.max(0, (timestamp - startTime) / durationMs));
        const easedRatio = 1 - Math.pow(1 - elapsedRatio, 3);
        progress.value = previousValue + (nextValue - previousValue) * easedRatio;
        if (elapsedRatio < 1) {
          this.progressAnimationFrame = window.requestAnimationFrame(advance);
        } else {
          this.progressAnimationFrame = null;
          track.classList.remove('is-charging');
        }
      };
      this.progressAnimationFrame = window.requestAnimationFrame(advance);
    }

    showSuccess(section, animate) {
      const form = section.querySelector('form');
      for (const message of form.querySelectorAll('[data-server-success], [data-server-error]')) message.hidden = true;
      form.querySelector('button').disabled = true;
      form.querySelector('input[type="email"]').disabled = true;
      form.querySelector('[data-submit-label]').textContent = section.querySelector('[data-subscribed-template]').content.textContent.trim();
      form.querySelector('[data-submit-icon]').textContent = '✓';
      section.querySelector('[data-subscription-status]').replaceChildren(section.querySelector('[data-success-template]').content.cloneNode(true));
      if (animate && !this.motionQuery.matches) {
        const increment = section.querySelector('[data-increment]');
        increment.hidden = false;
        increment.classList.add('is-visible');
        this.schedule(() => { increment.hidden = true; increment.classList.remove('is-visible'); }, 1100);
      }
    }

    showError(section) {
      section.querySelector('[data-subscription-status]').replaceChildren(section.querySelector('[data-error-template]').content.cloneNode(true));
    }

    /** 原站客户表单提交：仅 Shopify 成功标记允许更新人数；错误、超时保持原数值。 */
    async submitSubscription(event, section, state) {
      event.preventDefault();
      const form = event.currentTarget;
      const button = form.querySelector('button');
      if (state.busy || !form.reportValidity() || button.disabled) return;
      state.busy = true;
      button.disabled = true;
      form.setAttribute('aria-busy', 'true');
      const controller = new AbortController();
      this.requests.add(controller);
      const timeout = window.setTimeout(() => controller.abort(), 15000);
      let succeeded = false;
      try {
        const action = new URL(form.action, window.location.href);
        if (action.origin !== window.location.origin) throw new Error('订阅地址必须属于当前商店。');
        const response = await fetch(action, {method:'POST', body:new FormData(form), credentials:'same-origin', redirect:'follow', headers:{Accept:'text/html'}, signal:controller.signal});
        if (!response.ok) throw new Error(`订阅响应异常：${response.status}`);
        const returnedDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
        const returnedForm = returnedDocument.getElementById(form.id);
        if (!returnedForm?.querySelector('[data-server-success]')) {
          // Shopify 要求验证码时交回原生表单处理，不把验证页面当作订阅成功。
          const finalUrl = new URL(response.url, window.location.href);
          if (finalUrl.origin === action.origin && /\/challenge(?:\/|$)/.test(finalUrl.pathname)) {
            HTMLFormElement.prototype.submit.call(form);
            return;
          }
          const message = returnedForm?.querySelector('[data-server-error]')?.textContent.trim();
          if (message) section.querySelector('[data-subscription-status]').textContent = message;
          else this.showError(section);
          return;
        }
        if (!this.isConnected) return;
        succeeded = true;
        state.count = this.recordSubscription(state);
        this.updateCount(section, state.count, true);
        this.showSuccess(section, true);
      } catch (error) {
        if (this.isConnected) {
          console.warn('海洋活动：订阅未完成。', error);
          this.showError(section);
        }
      } finally {
        window.clearTimeout(timeout);
        this.requests.delete(controller);
        form.removeAttribute('aria-busy');
        if (!succeeded) button.disabled = false;
        state.busy = false;
      }
    }

    schedule(callback, delay) {
      const timer = window.setTimeout(() => {this.timers.delete(timer); callback();}, delay);
      this.timers.add(timer);
    }

    // 跨域素材先转成 Blob 再下载；失败时显示原文件链接供用户保存。
    async downloadFile(event) {
      const link = event.target.closest('[data-download], [data-poster-download]');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (link.getAttribute('aria-busy') === 'true') return;
      link.setAttribute('aria-busy', 'true');
      const controller = new AbortController();
      this.requests.add(controller);
      const timeout = window.setTimeout(() => controller.abort(), 60000);
      try {
        const url = new URL(link.href, window.location.href);
        if (!['https:', 'http:'].includes(url.protocol)) throw new Error('不支持的下载地址。');
        const response = await fetch(url, {credentials:'omit', signal:controller.signal});
        if (!response.ok) throw new Error(`素材响应异常：${response.status}`);
        let blob = await response.blob();
        if (!blob.size) throw new Error('下载素材为空。');
        if (link.dataset.convertPng === 'true') blob = await this.convertPosterToPng(blob);
        if (!this.isConnected) return;
        const objectUrl = URL.createObjectURL(blob);
        this.objectUrls.add(objectUrl);
        const anchor = document.createElement('a');
        anchor.href = objectUrl;
        anchor.download = link.dataset.filename || link.download;
        this.append(anchor);
        anchor.click();
        anchor.remove();
        this.schedule(() => {URL.revokeObjectURL(objectUrl); this.objectUrls.delete(objectUrl);}, 60000);
      } catch (error) {
        if (this.isConnected) {
          console.warn('海洋活动：素材下载未完成。', error);
          const status = this.querySelector('[data-download-status]');
          status.replaceChildren(this.querySelector('[data-download-error]').content.cloneNode(true));
          const fallback = link.cloneNode(true);
          for (const attribute of ['data-download','data-poster-download','aria-busy','download']) fallback.removeAttribute(attribute);
          status.append(fallback);
          status.hidden = false;
          this.schedule(() => {status.hidden = true;}, 15000);
        }
      } finally {
        window.clearTimeout(timeout);
        this.requests.delete(controller);
        link.removeAttribute('aria-busy');
      }
    }

    /** 将原始 SVG 或自选图片原样绘制为 PNG，限制输出尺寸，避免移动端内存过高。 */
    async convertPosterToPng(blob) {
      const sourceUrl = URL.createObjectURL(blob);
      this.objectUrls.add(sourceUrl);
      try {
        const image = new Image();
        image.src = sourceUrl;
        await image.decode();
        if (!image.naturalWidth || !image.naturalHeight) throw new Error('海报尺寸无效。');
        const scale = Math.min(2, 2160/image.naturalWidth, 3840/image.naturalHeight);
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(image.naturalWidth*scale);
        canvas.height = Math.round(image.naturalHeight*scale);
        const context = canvas.getContext('2d');
        if (!context) throw new Error('浏览器无法导出海报。');
        context.drawImage(image,0,0,canvas.width,canvas.height);
        return await new Promise((resolve,reject) => canvas.toBlob(result => result ? resolve(result) : reject(new Error('PNG 导出失败。')), 'image/png'));
      } finally {
        URL.revokeObjectURL(sourceUrl);
        this.objectUrls.delete(sourceUrl);
      }
    }
  }
  customElements.define('ocean-ritual', OceanRitual);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pride-add-to-cart-banner"] && !Shopify.designMode) return;
  try {
    
  /**
   * 彩虹加购横幅
   * 点击 / 回车 / 空格 → 找到本页主商品区的 Add to Cart 按钮并触发它，
   * 复用主题既有的加购逻辑（变体、数量、AJAX、购物车抽屉、错误提示）。
   */
  class PrideAddToCartBanner extends HTMLElement {
    constructor() {
      super();
      this.handleActivate = this.handleActivate.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleActivate);
      this.addEventListener('keydown', this.handleActivate);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleActivate);
      this.removeEventListener('keydown', this.handleActivate);
    }

    handleActivate(event) {
      // 键盘事件只响应 Enter / 空格，避免误触发
      if (event.type === 'keydown') {
        const key = event.key;
        if (key !== 'Enter' && key !== ' ' && key !== 'Spacebar') return;
        event.preventDefault();
      }

      const addButton = this.findAddToCartButton();
      if (!addButton) {
        // 兜底：找不到加购按钮时，滚动到商品表单位置，避免点击无反应
        const form = document.querySelector('product-form, form[data-type="add-to-cart-form"]');
        if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      // 缺货 / 禁用时滚动到按钮，让用户看到不可购买状态
      if (addButton.disabled) {
        addButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      addButton.click();
    }

    /**
     * 定位主商品区的加购按钮。
     * buy-buttons / buy-buttons-zl 两套组件都使用 [name="add"].product-form__submit。
     * 优先取可见且未禁用的按钮，避免命中粘性/隐藏的重复按钮。
     */
    findAddToCartButton() {
      const selector =
        'product-form button[name="add"], form[data-type="add-to-cart-form"] button[name="add"], button[name="add"].product-form__submit';
      const candidates = Array.from(document.querySelectorAll(selector));
      if (candidates.length === 0) return null;

      const visibleEnabled = candidates.find(
        (btn) => !btn.disabled && btn.offsetParent !== null
      );
      if (visibleEnabled) return visibleEnabled;

      const enabled = candidates.find((btn) => !btn.disabled);
      return enabled || candidates[0];
    }
  }

  if (!customElements.get('pride-add-to-cart-banner')) {
    customElements.define('pride-add-to-cart-banner', PrideAddToCartBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pride-limited-feature"] && !Shopify.designMode) return;
  try {
    
  /**
   * Pride 限量模块加购按钮
   * ------------------------------------------------------------
   * 只负责触发主商品区的 Add to Cart，不重新实现加购流程。
   * 这样可以复用当前变体、数量、AJAX 加购、购物车抽屉和错误提示。
   */
  class PrideLimitedFeatureAddToCart extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick(event) {
      const triggerButton = event.target.closest('.pride-limited-feature__button');
      if (!triggerButton) return;

      event.preventDefault();
      const addButton = this.findPrimaryAddToCartButton();

      if (!addButton) {
        this.scrollToPrimaryProductForm();
        return;
      }

      if (addButton.disabled || addButton.getAttribute('aria-disabled') === 'true') {
        addButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      addButton.click();
    }

    /**
     * 定位主商品区的加购按钮。
     * 优先使用可见且可点击的按钮，避免命中隐藏的 sticky 表单或重复表单。
     */
    findPrimaryAddToCartButton() {
      const selector =
        'main product-form button[name="add"], main form[data-type="add-to-cart-form"] button[name="add"], product-form button[name="add"], form[data-type="add-to-cart-form"] button[name="add"], button[name="add"].product-form__submit';
      const candidates = Array.from(document.querySelectorAll(selector)).filter(
        (button) => !this.contains(button)
      );

      if (candidates.length === 0) return null;

      const visibleEnabledButton = candidates.find(
        (button) =>
          !button.disabled &&
          button.getAttribute('aria-disabled') !== 'true' &&
          button.offsetParent !== null
      );
      if (visibleEnabledButton) return visibleEnabledButton;

      const enabledButton = candidates.find(
        (button) =>
          !button.disabled && button.getAttribute('aria-disabled') !== 'true'
      );
      return enabledButton || candidates[0];
    }

    /**
     * 找不到加购按钮时滚动到商品表单区域，避免点击后没有任何反馈。
     */
    scrollToPrimaryProductForm() {
      const form = document.querySelector(
        'main product-form, main form[data-type="add-to-cart-form"], product-form, form[data-type="add-to-cart-form"]'
      );
      if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  if (!customElements.get('pride-limited-feature-add-to-cart')) {
    customElements.define(
      'pride-limited-feature-add-to-cart',
      PrideLimitedFeatureAddToCart
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-kol-videos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.reviewKolVideosInitialized) return;
    window.reviewKolVideosInitialized = true;

    const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const getState = (root) => {
      root.reviewKolVideosState = root.reviewKolVideosState || {
        index: 0,
        timer: null,
        paused: false,
        returnFocus: null,
      };
      return root.reviewKolVideosState;
    };

    const getSlides = (root) => Array.from(root.querySelectorAll('[data-review-kol-slide]'));

    const stopAutoplay = (root) => {
      const state = getState(root);
      if (state.timer) {
        window.clearInterval(state.timer);
        state.timer = null;
      }
    };

    const getMaxOffset = (root) => {
      const viewport = root.querySelector('[data-review-kol-viewport]');
      const track = root.querySelector('[data-review-kol-track]');
      if (!viewport || !track) return 0;
      return Math.max(0, track.scrollWidth - viewport.clientWidth);
    };

    const getMaxIndex = (root) => {
      const slides = getSlides(root);
      const maxOffset = getMaxOffset(root);
      return slides.reduce((maxIndex, slide, index) => {
        return slide.offsetLeft <= maxOffset + 1 ? index : maxIndex;
      }, 0);
    };

    const updateArrowState = (root) => {
      const state = getState(root);
      const maxIndex = getMaxIndex(root);
      const previousButton = root.querySelector('[data-review-kol-prev]');
      const nextButton = root.querySelector('[data-review-kol-next]');

      if (previousButton) {
        const isDisabled = state.index <= 0;
        previousButton.disabled = isDisabled;
        previousButton.setAttribute('aria-disabled', String(isDisabled));
      }

      if (nextButton) {
        const isDisabled = state.index >= maxIndex;
        nextButton.disabled = isDisabled;
        nextButton.setAttribute('aria-disabled', String(isDisabled));
      }
    };

    const setActive = (root, nextIndex) => {
      const state = getState(root);
      const slides = getSlides(root);
      const track = root.querySelector('[data-review-kol-track]');
      if (!track || slides.length === 0) return;

      const maxIndex = getMaxIndex(root);
      const clampedIndex = Math.min(Math.max(nextIndex, 0), maxIndex);
      const offset = Math.min(slides[clampedIndex].offsetLeft, getMaxOffset(root));
      state.index = clampedIndex;
      track.style.transform = `translateX(-${offset}px)`;
      updateArrowState(root);
    };

    const canAutoplay = (root) => {
      const modal = root.querySelector('[data-review-kol-modal]');
      const hasOpenModal = modal && !modal.hidden;
      return root.dataset.autoplay === 'true' && getSlides(root).length > 1 && !reduceMotionQuery.matches && !hasOpenModal;
    };

    const startAutoplay = (root) => {
      const state = getState(root);
      stopAutoplay(root);
      if (!canAutoplay(root) || state.paused) return;

      const delay = Number(root.dataset.autoplayDelay) || 5000;
      state.timer = window.setInterval(() => {
        if (state.index >= getMaxIndex(root)) {
          stopAutoplay(root);
          return;
        }

        setActive(root, state.index + 1);
      }, delay);
    };

    const getEmbedUrl = (provider, id) => {
      if (!provider || !id) return '';
      if (provider === 'youtube') return `https://www.youtube.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0&modestbranding=1`;
      if (provider === 'vimeo') return `https://player.vimeo.com/video/${encodeURIComponent(id)}?autoplay=1`;
      return '';
    };

    const closeModal = (root) => {
      const state = getState(root);
      const modal = root.querySelector('[data-review-kol-modal]');
      const frame = root.querySelector('[data-review-kol-frame]');
      if (!modal || !frame) return;

      modal.hidden = true;
      frame.innerHTML = '';
      if (state.returnFocus && typeof state.returnFocus.focus === 'function') state.returnFocus.focus();
      state.returnFocus = null;
      startAutoplay(root);
    };

    const openModal = (root, button) => {
      const state = getState(root);
      const modal = root.querySelector('[data-review-kol-modal]');
      const frame = root.querySelector('[data-review-kol-frame]');
      const closeButton = root.querySelector('[data-review-kol-close-button]');
      let embedUrl = getEmbedUrl(button.dataset.videoProvider, button.dataset.videoId);
      if (!modal || !frame || !embedUrl) return;

      stopAutoplay(root);
      state.returnFocus = button;
      const startSeconds = Number(button.dataset.videoStart) || 0;
      if (button.dataset.videoProvider === 'youtube' && startSeconds > 0) embedUrl += `&start=${startSeconds}`;

      frame.innerHTML = '';
      const iframe = document.createElement('iframe');
      iframe.src = embedUrl;
      iframe.title = button.dataset.videoTitle || 'Video player';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      frame.appendChild(iframe);
      modal.hidden = false;
      if (closeButton) closeButton.focus();
    };

    const initializeRoot = (root) => {
      if (root.dataset.reviewKolInitialized === 'true') return;
      root.dataset.reviewKolInitialized = 'true';

      setActive(root, getState(root).index);
      startAutoplay(root);

      root.addEventListener('mouseenter', () => {
        getState(root).paused = true;
        stopAutoplay(root);
      });

      root.addEventListener('mouseleave', () => {
        getState(root).paused = false;
        startAutoplay(root);
      });

      root.addEventListener('focusin', () => {
        getState(root).paused = true;
        stopAutoplay(root);
      });

      root.addEventListener('focusout', () => {
        getState(root).paused = false;
        startAutoplay(root);
      });
    };

    document.addEventListener('click', (event) => {
      const previousButton = event.target.closest('[data-review-kol-prev]');
      const nextButton = event.target.closest('[data-review-kol-next]');
      const videoButton = event.target.closest('[data-review-kol-video]');
      const closeButton = event.target.closest('[data-review-kol-close]');
      const control = previousButton || nextButton || videoButton || closeButton;
      if (!control) return;

      const root = control.closest('[data-review-kol-root]');
      if (!root) return;

      if (closeButton) {
        closeModal(root);
        return;
      }

      if (videoButton) {
        openModal(root, videoButton);
        return;
      }

      const state = getState(root);
      if (previousButton) setActive(root, state.index - 1);
      if (nextButton) setActive(root, state.index + 1);
      startAutoplay(root);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-review-kol-root]').forEach((root) => {
        const modal = root.querySelector('[data-review-kol-modal]');
        if (modal && !modal.hidden) closeModal(root);
      });
    });

    const refreshRoots = () => {
      document.querySelectorAll('[data-review-kol-root]').forEach((root) => {
        initializeRoot(root);
        setActive(root, getState(root).index);
        startAutoplay(root);
      });
    };

    refreshRoots();
    window.addEventListener('resize', refreshRoots);
    document.addEventListener('shopify:section:load', refreshRoots);
    if (typeof reduceMotionQuery.addEventListener === 'function') reduceMotionQuery.addEventListener('change', refreshRoots);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-partner-program"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeCarousel = (carousel) => {
      if (carousel.dataset.initialized === 'true') return;
      carousel.dataset.initialized = 'true';

      const track = carousel.querySelector('[data-carousel-track]');
      const cards = Array.from(track?.children || []);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let timer = null;
      let scrollFrame = null;
      let activeIndex = 0;
      let pointerPaused = false;
      let focusPaused = false;
      let isDragging = false;
      let dragStartX = 0;
      let dragStartScrollLeft = 0;

      if (!track || cards.length === 0) return;

      const cardStep = () => {
        const card = cards[0];
        const styles = window.getComputedStyle(track);
        return card.getBoundingClientRect().width + Number.parseFloat(styles.columnGap || styles.gap || 0);
      };

      const maximumIndex = () => {
        const step = cardStep();
        if (step <= 0) return 0;
        return Math.max(0, Math.round((track.scrollWidth - track.clientWidth) / step));
      };

      const updateActiveIndex = (index) => {
        const lastIndex = maximumIndex();
        activeIndex = Math.max(0, Math.min(index, lastIndex));
      };

      const goTo = (index, behavior = 'smooth') => {
        const lastIndex = maximumIndex();
        const nextIndex = index > lastIndex ? 0 : index < 0 ? lastIndex : index;
        track.scrollTo({ left: cardStep() * nextIndex, behavior: reducedMotion.matches ? 'auto' : behavior });
        updateActiveIndex(nextIndex);
      };

      const stopAutoPlay = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
      };

      const startAutoPlay = () => {
        stopAutoPlay();
        if (reducedMotion.matches || pointerPaused || focusPaused || isDragging) return;
        track.setAttribute('aria-live', 'off');
        timer = window.setInterval(() => goTo(activeIndex + 1), 5000);
      };

      const updateFromScroll = () => updateActiveIndex(Math.round(track.scrollLeft / cardStep()));
      const handlePointerDown = (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        isDragging = true;
        dragStartX = event.clientX;
        dragStartScrollLeft = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
        stopAutoPlay();
        event.preventDefault();
      };
      const handlePointerMove = (event) => {
        if (!isDragging || event.pointerType !== 'mouse') return;
        track.scrollLeft = dragStartScrollLeft - (event.clientX - dragStartX);
        event.preventDefault();
      };
      const handlePointerEnd = (event) => {
        if (!isDragging || event.pointerType !== 'mouse') return;
        isDragging = false;
        track.classList.remove('is-dragging');
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
        updateFromScroll();
        startAutoPlay();
      };
      const handleScroll = () => {
        if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => {
          scrollFrame = null;
          updateFromScroll();
        });
      };
      const handleMotionChange = () => {
        track.setAttribute('aria-live', reducedMotion.matches ? 'polite' : 'off');
        startAutoPlay();
      };
      const handleResize = () => {
        updateActiveIndex(activeIndex);
        goTo(activeIndex, 'auto');
      };

      track.addEventListener('scroll', handleScroll, { passive: true });
      track.addEventListener('scrollend', updateFromScroll);
      track.addEventListener('pointerdown', handlePointerDown);
      track.addEventListener('pointermove', handlePointerMove);
      track.addEventListener('pointerup', handlePointerEnd);
      track.addEventListener('pointercancel', handlePointerEnd);
      carousel.addEventListener('mouseenter', () => {
        pointerPaused = true;
        stopAutoPlay();
      });
      carousel.addEventListener('mouseleave', () => {
        pointerPaused = false;
        startAutoPlay();
      });
      carousel.addEventListener('focusin', () => {
        focusPaused = true;
        stopAutoPlay();
      });
      carousel.addEventListener('focusout', (event) => {
        if (carousel.contains(event.relatedTarget)) return;
        focusPaused = false;
        startAutoPlay();
      });
      reducedMotion.addEventListener?.('change', handleMotionChange);
      window.addEventListener('resize', handleResize);

      carousel.storePartnerDestroy = () => {
        stopAutoPlay();
        if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
        track.removeEventListener('scroll', handleScroll);
        track.removeEventListener('scrollend', updateFromScroll);
        track.removeEventListener('pointerdown', handlePointerDown);
        track.removeEventListener('pointermove', handlePointerMove);
        track.removeEventListener('pointerup', handlePointerEnd);
        track.removeEventListener('pointercancel', handlePointerEnd);
        reducedMotion.removeEventListener?.('change', handleMotionChange);
        window.removeEventListener('resize', handleResize);
      };

      updateActiveIndex(0);
      handleMotionChange();
    };

    const initializeContactTriggers = (root = document) => {
      root.querySelectorAll('[data-store-partner-contact-trigger]').forEach((trigger) => {
        if (trigger.dataset.storePartnerContactInitialized === 'true') return;

        trigger.dataset.storePartnerContactInitialized = 'true';
        trigger.addEventListener('click', (event) => {
          event.preventDefault();

          const modal = document.getElementById('ContactModal');

          if (!modal) {
            console.error('[Store Partner Program] B2B contact form modal was not found.');
            return;
          }

          const successMessage = modal.querySelector('#ZohoSuccessMessage');
          const formGrid = modal.querySelector('#ZohoFormGrid');
          const submitButton = modal.querySelector('#ZohoSubmitBtn');

          if (successMessage) successMessage.style.display = 'none';
          if (formGrid) formGrid.style.display = 'grid';
          if (submitButton) {
            submitButton.removeAttribute('disabled');
            submitButton.style.display = '';
            submitButton.style.opacity = '';
            submitButton.style.cursor = '';
          }

          modal.style.display = 'flex';
          modal.querySelector('.close-modal-btn')?.focus();
        });
      });
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll('[data-store-partner-carousel]').forEach(initializeCarousel);
      initializeContactTriggers(root);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-store-partner-carousel]').forEach((carousel) => {
        carousel.storePartnerDestroy?.();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["user-manuals"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.userManualsInitialized) return;
    window.userManualsInitialized = true;

    const activateTab = (root, tab) => {
      const targetId = tab.dataset.userManualsTarget;
      if (!targetId) return;

      root.querySelectorAll('[data-user-manuals-tab]').forEach((item) => {
        const isActive = item === tab;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', String(isActive));
        item.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      root.querySelectorAll('[data-user-manuals-group]').forEach((panel) => {
        const isActive = panel.id === targetId;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    };

    // Section Block 数量可变，Tab 根据当前已渲染的 Manual Group 节点实时生成。
    const buildTabs = (root) => {
      const groupsContainer = root.querySelector('[data-user-manuals-groups]');
      if (!groupsContainer) return [];

      const groups = Array.from(groupsContainer.querySelectorAll(':scope > [data-user-manuals-group]'));
      root.querySelector('[data-user-manuals-tabs]')?.remove();

      if (groups.length <= 1) {
        const onlyGroup = groups[0];
        if (onlyGroup) {
          onlyGroup.hidden = false;
          onlyGroup.classList.add('is-active');
          onlyGroup.removeAttribute('role');
          onlyGroup.removeAttribute('aria-labelledby');
        }
        return [];
      }

      const tabList = document.createElement('div');
      tabList.className = 'user-manuals__tabs';
      tabList.dataset.userManualsTabs = '';
      tabList.setAttribute('role', 'tablist');
      tabList.setAttribute('aria-label', groupsContainer.dataset.userManualsTablistLabel || 'Manual groups');

      const tabs = groups.map((group, index) => {
        const tabId = `${group.id}-tab`;
        const tab = document.createElement('button');
        tab.className = 'user-manuals__tab';
        tab.id = tabId;
        tab.type = 'button';
        tab.dataset.userManualsTab = '';
        tab.dataset.userManualsTarget = group.id;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', group.id);
        tab.textContent = group.dataset.userManualsGroupTitle || `Manual ${index + 1}`;

        group.setAttribute('role', 'tabpanel');
        group.setAttribute('aria-labelledby', tabId);
        tabList.append(tab);
        return tab;
      });

      groupsContainer.before(tabList);
      return tabs;
    };

    const initializeRoot = (root) => {
      const activeGroupId = root.querySelector('[data-user-manuals-group].is-active')?.id;
      const tabs = buildTabs(root);
      if (!tabs.length) return;

      const selected = tabs.find((tab) => tab.dataset.userManualsTarget === activeGroupId) || tabs[0];
      activateTab(root, selected);
    };

    document.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-user-manuals-tab]');
      if (!tab) return;

      const root = tab.closest('[data-user-manuals-root]');
      if (!root) return;

      activateTab(root, tab);
    });

    document.addEventListener('keydown', (event) => {
      const tab = event.target.closest('[data-user-manuals-tab]');
      if (!tab) return;

      const root = tab.closest('[data-user-manuals-root]');
      const tabs = Array.from(root.querySelectorAll('[data-user-manuals-tab]'));
      const currentIndex = tabs.indexOf(tab);
      if (currentIndex === -1) return;

      let nextIndex = currentIndex;
      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = tabs.length - 1;
      if (nextIndex === currentIndex) return;

      event.preventDefault();
      tabs[nextIndex].focus();
      activateTab(root, tabs[nextIndex]);
    });

    const refreshRoots = () => {
      document.querySelectorAll('[data-user-manuals-root]').forEach(initializeRoot);
    };

    refreshRoots();
    document.addEventListener('shopify:section:load', refreshRoots);
    document.addEventListener('shopify:block:select', (event) => {
      const panel = event.target.closest('[data-user-manuals-group]');
      if (!panel) return;

      const root = panel.closest('[data-user-manuals-root]');
      if (!root) return;

      const tab = root.querySelector(`[data-user-manuals-target="${panel.id}"]`);
      if (tab) activateTab(root, tab);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vita-customer-videos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.vitaCustomerVideosController && typeof window.vitaCustomerVideosController.abort === 'function') {
      window.vitaCustomerVideosController.abort();
    }

    const resetMedia = (overlay) => {
      const media = overlay.querySelector('[data-vita-video-media]');
      if (media) media.dataset.mediaActive = 'false';

      overlay.querySelectorAll('video[data-vita-video-frame]').forEach((video) => {
        video.pause();
        video.removeAttribute('src');
        video.load();
      });
      overlay.querySelectorAll('[data-vita-video-frame]').forEach((frame) => frame.remove());
    };

    const playMedia = (overlay) => {
      const media = overlay.querySelector('[data-vita-video-media]');
      if (!media || !media.dataset.vitaVideoSrc) return;

      let frame = media.querySelector('[data-vita-video-frame]');
      if (!frame && media.dataset.vitaVideoType === 'vimeo') {
        frame = document.createElement('iframe');
        frame.setAttribute('title', media.dataset.vitaVideoTitle || 'Customer video');
        frame.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        frame.setAttribute('allowfullscreen', '');
        frame.dataset.vitaVideoFrame = 'true';
        media.append(frame);
      }

      if (!frame) {
        frame = document.createElement('video');
        frame.controls = true;
        frame.playsInline = true;
        frame.preload = 'metadata';
        if (media.dataset.vitaVideoPoster) frame.poster = media.dataset.vitaVideoPoster;
        frame.dataset.vitaVideoFrame = 'true';
        media.append(frame);
      }

      media.dataset.mediaActive = 'true';
      if (!frame.getAttribute('src')) frame.setAttribute('src', media.dataset.vitaVideoSrc);
      if (frame.tagName !== 'VIDEO') return;

      const playRequest = frame.play();
      if (playRequest && typeof playRequest.catch === 'function') {
        playRequest.catch(() => {
          frame.controls = true;
        });
      }
    };

    const closeOverlay = (overlay) => {
      if (!overlay) return;
      overlay.dataset.state = 'closed';
      overlay.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('vita-customer-videos-lock');
      resetMedia(overlay);
    };

    const openOverlay = (overlay) => {
      if (!overlay) return;
      overlay.dataset.state = 'open';
      overlay.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('vita-customer-videos-lock');
      resetMedia(overlay);
      const closeButton = overlay.querySelector('[data-vita-video-close]');
      if (closeButton) closeButton.focus({ preventScroll: true });
    };

    const initScrollableTracks = (container = document) => {
      container.querySelectorAll('[data-vita-video-track]').forEach((track) => {
        if (track.dataset.vitaVideoDragBound === 'true') return;
        track.dataset.vitaVideoDragBound = 'true';

        let isDragging = false;
        let hasDragged = false;
        let startX = 0;
        let lastClientX = 0;
        let startIndex = 0;
        let startScrollLeft = 0;
        let snapTimer = null;
        const mobileOneCardQuery = window.matchMedia('(max-width: 749px)');

        const getVideoCards = () => Array.from(track.querySelectorAll('[data-vita-video-card]'));

        const getVideoCardScrollLeft = (card) => {
          const cardRect = card.getBoundingClientRect();
          const trackRect = track.getBoundingClientRect();

          // 按卡片相对 track 的位置计算滚动目标，避免把页面左右 padding 算进 scrollLeft。
          return track.scrollLeft + cardRect.left - trackRect.left;
        };

        const getClosestVideoCardIndex = () => {
          const cards = getVideoCards();
          if (cards.length === 0) return 0;

          return cards.reduce((closestIndex, card, index) => {
            const currentDistance = Math.abs(getVideoCardScrollLeft(card) - track.scrollLeft);
            const closestDistance = Math.abs(getVideoCardScrollLeft(cards[closestIndex]) - track.scrollLeft);
            return currentDistance < closestDistance ? index : closestIndex;
          }, 0);
        };

        const scrollToVideoCard = (index, smooth = true) => {
          const cards = getVideoCards();
          if (cards.length === 0) return;

          const targetIndex = Math.max(0, Math.min(index, cards.length - 1));
          track.scrollTo({
            left: getVideoCardScrollLeft(cards[targetIndex]),
            behavior: smooth ? 'smooth' : 'auto'
          });
        };

        const snapToNearestVideoCard = () => {
          if (!mobileOneCardQuery.matches) return;
          scrollToVideoCard(getClosestVideoCardIndex());
        };

        const stepOneVideoCard = () => {
          if (!mobileOneCardQuery.matches) return false;

          const cards = getVideoCards();
          if (cards.length < 2) return false;

          const dragDistance = lastClientX - startX;
          const triggerDistance = Math.min(Math.max(track.clientWidth * 0.14, 36), 80);
          let targetIndex = getClosestVideoCardIndex();

          // H5 手势每次只推进或后退一张，避免快速拖动停在两张之间。
          if (dragDistance <= -triggerDistance) {
            targetIndex = startIndex + 1;
          } else if (dragDistance >= triggerDistance) {
            targetIndex = startIndex - 1;
          }

          scrollToVideoCard(targetIndex);
          return true;
        };

        const scheduleMobileSnap = () => {
          if (isDragging || !mobileOneCardQuery.matches) return;
          window.clearTimeout(snapTimer);
          snapTimer = window.setTimeout(snapToNearestVideoCard, 120);
        };

        const stopDragging = (event) => {
          if (!isDragging) return;
          isDragging = false;
          track.classList.remove('is-dragging');
          if (event.pointerId !== undefined && typeof track.releasePointerCapture === 'function') {
            try {
              track.releasePointerCapture(event.pointerId);
            } catch (error) {
              // Shopify 预览中断拖拽时，指针捕获可能已经被释放。
            }
          }

          if (!hasDragged) return;
          stepOneVideoCard();
          track.dataset.vitaVideoDragged = 'true';
          window.setTimeout(() => {
            delete track.dataset.vitaVideoDragged;
          }, 120);
        };

        track.addEventListener('pointerdown', (event) => {
          if (event.button !== undefined && event.button !== 0) return;
          if (event.target instanceof Element && event.target.closest('button, a, input, select, textarea')) return;
          isDragging = true;
          hasDragged = false;
          startX = event.clientX;
          lastClientX = event.clientX;
          startIndex = getClosestVideoCardIndex();
          startScrollLeft = track.scrollLeft;
          track.classList.add('is-dragging');
          if (typeof track.setPointerCapture === 'function') {
            track.setPointerCapture(event.pointerId);
          }
        });

        track.addEventListener('pointermove', (event) => {
          if (!isDragging) return;
          lastClientX = event.clientX;
          const deltaX = event.clientX - startX;
          if (Math.abs(deltaX) < 4) return;
          hasDragged = true;
          track.scrollLeft = startScrollLeft - deltaX;
          event.preventDefault();
        });

        track.addEventListener('pointerup', stopDragging);
        track.addEventListener('pointercancel', stopDragging);
        track.addEventListener('lostpointercapture', stopDragging);
        track.addEventListener('scroll', scheduleMobileSnap, { passive: true });

        document.addEventListener('shopify:block:select', (event) => {
          const selectedCard = event.target instanceof Element ? event.target.closest('[data-vita-video-card]') : null;
          if (!selectedCard || !track.contains(selectedCard)) return;

          const selectedIndex = getVideoCards().indexOf(selectedCard);
          if (selectedIndex < 0) return;

          window.requestAnimationFrame(() => scrollToVideoCard(selectedIndex, false));
        });
      });
    };

    window.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : event.target && event.target.parentElement;
      if (!target) return;

      const opener = target.closest('[data-vita-video-open]');
      if (opener) {
        const track = opener.closest('[data-vita-video-track]');
        if (track?.dataset.vitaVideoDragged === 'true') {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        const overlay = document.getElementById(opener.dataset.vitaVideoOpen);
        if (!overlay) return;
        event.preventDefault();
        event.stopPropagation();
        openOverlay(overlay);
        return;
      }

      const cover = target.closest('[data-vita-video-cover]');
      if (cover) {
        const overlay = cover.closest('[data-vita-video-modal]');
        if (!overlay) return;
        event.preventDefault();
        event.stopPropagation();
        playMedia(overlay);
        return;
      }

      const closer = target.closest('[data-vita-video-close]');
      if (closer) {
        event.preventDefault();
        event.stopPropagation();
        closeOverlay(closer.closest('[data-vita-video-modal]'));
      }
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-vita-video-modal][data-state="open"]').forEach(closeOverlay);
      const targetedOverlay = document.querySelector('.vita-customer-videos__modal:target');
      closeOverlay(targetedOverlay);
    });

    window.addEventListener('hashchange', () => {
      const targetedOverlay = document.querySelector('.vita-customer-videos__modal:target');
      if (targetedOverlay) openOverlay(targetedOverlay);
    });

    initScrollableTracks();
    document.addEventListener('shopify:section:load', (event) => initScrollableTracks(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vita-feature-video"] && !Shopify.designMode) return;
  try {
    
  class VitaFeatureVideoPlayer extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.video = this.querySelector('[data-vita-feature-video]');
      this.playButton = this.querySelector('[data-vita-feature-play]');
      this.poster = this.querySelector('.vita-feature-video__poster');
      if (!this.video || !this.playButton) return;

      this.video.controls = false;
      this.classList.add('is-enhanced');

      this.playButton.addEventListener('click', () => this.startPlayback(), {
        signal: this.controller.signal
      });
      this.video.addEventListener('ended', () => this.resetPlayer(), {
        signal: this.controller.signal
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    async startPlayback() {
      this.classList.add('is-playing');
      this.video.controls = true;

      try {
        await this.video.play();
      } catch (error) {
        this.resetPlayer();
        console.error('Vita feature video playback failed.', error);
      }
    }

    resetPlayer() {
      this.classList.remove('is-playing');
      this.video.controls = false;
      if (this.video.readyState > 0) this.video.currentTime = 0;
    }
  }

  if (!customElements.get('vita-feature-video-player')) {
    customElements.define('vita-feature-video-player', VitaFeatureVideoPlayer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vita-mini-dual-modes"] && !Shopify.designMode) return;
  try {
    
  class VitaMiniDualModesAccordion extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.addEventListener('click', this.#handleCardClick.bind(this), { signal: this.abortController.signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    #handleCardClick(event) {
      const selectedToggle = event.target.closest('[data-mode-card-toggle]');
      if (!selectedToggle || !this.contains(selectedToggle)) return;

      const selectedCard = selectedToggle.closest('.vita-mini-dual-modes__card');
      const grid = this.querySelector('.vita-mini-dual-modes__grid');
      const cardToggles = this.querySelectorAll('[data-mode-card-toggle]');

      if (!selectedCard || !grid || cardToggles.length < 2) return;

      if (selectedCard.classList.contains('vita-mini-dual-modes__card--active')) {
        // 再次点击当前卡片时，清除选择状态并恢复初始的等宽布局。
        for (const cardToggle of cardToggles) {
          const card = cardToggle.closest('.vita-mini-dual-modes__card');
          card?.classList.remove('vita-mini-dual-modes__card--active');
          cardToggle.setAttribute('aria-pressed', 'false');
        }

        grid.classList.remove('is-expanded');
        return;
      }

      for (const cardToggle of cardToggles) {
        const card = cardToggle.closest('.vita-mini-dual-modes__card');
        const isSelected = card === selectedCard;

        card?.classList.toggle('vita-mini-dual-modes__card--active', isSelected);
        cardToggle.setAttribute('aria-pressed', String(isSelected));
      }

      grid.classList.add('is-expanded');
    }
  }

  if (!customElements.get('vita-mini-dual-modes-accordion')) {
    customElements.define('vita-mini-dual-modes-accordion', VitaMiniDualModesAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["womens-health-evidence"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('womens-health-evidence')) {
    class WomensHealthEvidence extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-evidence-viewport]');
        this.slides = [...this.querySelectorAll('[data-evidence-slide]')];
        this.dots = [...this.querySelectorAll('[data-evidence-dot]')];
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.activeIndex = 0;
        this.scrollTimer = null;
        this.autoplayTimer = null;
        this.handleVisibilityChange = () => document.hidden ? this.stopAutoplay() : this.startAutoplay();
        this.handleReducedMotionChange = () => this.startAutoplay();
        if (!this.viewport || this.slides.length < 2) return;

        this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.slideIndex), true)));
        this.viewport.addEventListener('scroll', () => this.handleScroll(), { passive: true });
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay());
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        this.reducedMotion.addEventListener('change', this.handleReducedMotionChange);
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        window.clearTimeout(this.scrollTimer);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        this.reducedMotion?.removeEventListener('change', this.handleReducedMotionChange);
      }

      goTo(index, manual = false) {
        const nextIndex = (index + this.slides.length) % this.slides.length;
        const targetSlide = this.slides[nextIndex];
        // 仅移动轮播自身的横向视口，避免 scrollIntoView 把 Shopify 编辑器页面纵向带到本模块。
        const targetOffset = this.viewport.scrollLeft + targetSlide.getBoundingClientRect().left - this.viewport.getBoundingClientRect().left;
        this.viewport.scrollTo({ left: targetOffset, behavior: this.reducedMotion.matches ? 'auto' : 'smooth' });
        this.updateDots(nextIndex);
        if (manual) this.startAutoplay();
      }

      handleScroll() {
        window.clearTimeout(this.scrollTimer);
        this.scrollTimer = window.setTimeout(() => {
          const viewportStart = this.viewport.getBoundingClientRect().left;
          let nearestIndex = 0;
          let nearestDistance = Number.POSITIVE_INFINITY;
          this.slides.forEach((slide, index) => {
            const distance = Math.abs(slide.getBoundingClientRect().left - viewportStart);
            if (distance < nearestDistance) { nearestDistance = distance; nearestIndex = index; }
          });
          this.updateDots(nearestIndex);
        }, 100);
      }

      updateDots(index) {
        this.activeIndex = index;
        this.dots.forEach((dot, dotIndex) => {
          if (dotIndex === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      startAutoplay() {
        this.stopAutoplay();
        if (this.reducedMotion.matches || document.hidden || this.matches(':hover') || this.matches(':focus-within')) return;
        const delay = Number(this.dataset.autoplayDelay) || 6000;
        this.autoplayTimer = window.setInterval(() => this.goTo(this.activeIndex + 1), delay);
      }

      stopAutoplay() {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
    customElements.define('womens-health-evidence', WomensHealthEvidence);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zl-ear-seed-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initEarSeedHero = (root = document) => {
      root.querySelectorAll('[data-zl-ear-seed-hero]').forEach((section) => {
        const stripMoneyHtml = (value) => {
          const template = document.createElement('template');
          template.innerHTML = String(value || '');

          return template.content.textContent || template.innerText || String(value || '').replace(/<[^>]*>/g, '');
        };

        const formatMoney = (cents) => {
          const amount = Number(cents || 0);
          const moneyFormat = section.dataset.moneyFormat || window.cartStrings?.money_format || window.themeGlobalVariables?.settings?.money_format;

          if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && moneyFormat) {
            return stripMoneyHtml(window.Shopify.formatMoney(amount, moneyFormat));
          }

          return `${window.cartStrings?.cart_symbol || '$'}${(amount / 100).toFixed(2)}`;
        };

        /**
         * 为当前 section 内的捆绑区块绑定变体、总价和批量加购逻辑。
         * 每个区块独立维护状态，避免主题编辑器热重载时产生重复监听。
         */
        const initBundleOffers = () => {
          section.querySelectorAll('[data-bundle-offer]').forEach((offer) => {
            if (offer.dataset.bundleOfferReady === 'true') return;

            const items = Array.from(offer.querySelectorAll('[data-bundle-item]'));
            const totalOutput = offer.querySelector('[data-bundle-total]');
            const submitButton = offer.querySelector('[data-bundle-submit]');
            const buttonLabel = offer.querySelector('[data-bundle-button-label]');
            const statusOutput = offer.querySelector('[data-bundle-status]');
            const eventController = new AbortController();
            let successResetTimer = 0;

            /**
             * 关闭一个自定义变体下拉框，并按需把焦点还给触发按钮。
             * @param {HTMLElement} customSelect 自定义下拉框根节点。
             * @param {boolean} restoreFocus 是否恢复触发按钮焦点。
             */
            const closeCustomSelect = (customSelect, restoreFocus = false) => {
              const trigger = customSelect?.querySelector('[data-bundle-custom-trigger]');
              const list = customSelect?.querySelector('[data-bundle-custom-list]');
              if (!trigger || !list) return;

              trigger.setAttribute('aria-expanded', 'false');
              list.hidden = true;
              if (restoreFocus) trigger.focus();
            };

            /**
             * 关闭当前捆绑组件中的其他变体下拉框，防止多个菜单同时展开。
             * @param {HTMLElement|null} excludedSelect 保持展开的下拉框。
             */
            const closeAllCustomSelects = (excludedSelect = null) => {
              offer.querySelectorAll('[data-bundle-custom-select]').forEach((customSelect) => {
                if (customSelect !== excludedSelect) closeCustomSelect(customSelect);
              });
            };

            /**
             * 获取下拉菜单内可选且可聚焦的变体。
             * @param {HTMLElement} list 下拉菜单节点。
             * @returns {HTMLButtonElement[]}
             */
            const getEnabledCustomOptions = (list) => Array.from(
              list?.querySelectorAll('[data-bundle-custom-option]:not(:disabled)') || []
            );

            /**
             * 展开变体菜单，并把焦点放到当前、首个或末个可用变体。
             * @param {HTMLElement} customSelect 自定义下拉框根节点。
             * @param {'selected'|'first'|'last'} focusPosition 初始焦点位置。
             */
            const openCustomSelect = (customSelect, focusPosition = 'selected') => {
              const trigger = customSelect?.querySelector('[data-bundle-custom-trigger]');
              const list = customSelect?.querySelector('[data-bundle-custom-list]');
              if (!trigger || !list) return;

              closeAllCustomSelects(customSelect);
              trigger.setAttribute('aria-expanded', 'true');
              list.hidden = false;

              const enabledOptions = getEnabledCustomOptions(list);
              let focusTarget = enabledOptions.find((option) => option.getAttribute('aria-selected') === 'true')
                || enabledOptions[0];

              if (focusPosition === 'first') focusTarget = enabledOptions[0];
              if (focusPosition === 'last') focusTarget = enabledOptions[enabledOptions.length - 1];

              window.requestAnimationFrame(() => focusTarget?.focus());
            };

            /**
             * 将原生 select 渐进增强为可键盘操作的自定义下拉框。
             * 原生控件仍保留在 DOM 中，负责变体数据和无脚本回退。
             * @param {HTMLElement} item 商品行节点。
             */
            const initializeCustomSelect = (item) => {
              const variantSelect = item.querySelector('[data-bundle-variant-select]');
              const customSelect = item.querySelector('[data-bundle-custom-select]');
              const trigger = customSelect?.querySelector('[data-bundle-custom-trigger]');
              const list = customSelect?.querySelector('[data-bundle-custom-list]');
              const variantLabel = item.querySelector('.bundle-offer__variant-label');
              if (!variantSelect || !customSelect || !trigger || !list || !variantLabel) return;

              variantLabel.classList.add('is-enhanced');
              customSelect.hidden = false;
              variantSelect.tabIndex = -1;
              variantSelect.setAttribute('aria-hidden', 'true');

              const nativeLabel = variantSelect.labels?.[0]?.textContent?.trim();
              if (nativeLabel) trigger.setAttribute('aria-label', nativeLabel);

              trigger.addEventListener('click', () => {
                const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
                if (isExpanded) {
                  closeCustomSelect(customSelect);
                } else {
                  openCustomSelect(customSelect);
                }
              }, { signal: eventController.signal });

              trigger.addEventListener('keydown', (event) => {
                if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
                  event.preventDefault();
                  openCustomSelect(customSelect, event.key === 'ArrowUp' ? 'last' : 'first');
                }

                if (event.key === 'Escape') {
                  closeCustomSelect(customSelect);
                }
              }, { signal: eventController.signal });

              list.querySelectorAll('[data-bundle-custom-option]').forEach((option) => {
                option.tabIndex = -1;

                option.addEventListener('click', () => {
                  if (option.disabled) return;

                  variantSelect.value = option.dataset.variantValue || '';
                  variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
                  closeCustomSelect(customSelect, true);
                }, { signal: eventController.signal });

                option.addEventListener('keydown', (event) => {
                  const enabledOptions = getEnabledCustomOptions(list);
                  const currentIndex = enabledOptions.indexOf(option);
                  let focusIndex = currentIndex;

                  if (event.key === 'ArrowDown') {
                    focusIndex = (currentIndex + 1) % enabledOptions.length;
                  } else if (event.key === 'ArrowUp') {
                    focusIndex = (currentIndex - 1 + enabledOptions.length) % enabledOptions.length;
                  } else if (event.key === 'Home') {
                    focusIndex = 0;
                  } else if (event.key === 'End') {
                    focusIndex = enabledOptions.length - 1;
                  } else if (event.key === 'Escape') {
                    event.preventDefault();
                    closeCustomSelect(customSelect, true);
                    return;
                  } else if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    option.click();
                    return;
                  } else if (event.key === 'Tab') {
                    closeCustomSelect(customSelect);
                    return;
                  } else {
                    return;
                  }

                  event.preventDefault();
                  enabledOptions[focusIndex]?.focus();
                }, { signal: eventController.signal });
              });
            };

            /**
             * 读取商品行当前变体，并同步图片、价格、库存和勾选状态。
             * @param {HTMLElement} item 商品行节点。
             */
            const updateItemVariant = (item) => {
              const variantSelect = item.querySelector('[data-bundle-variant-select]');
              const selectedOption = variantSelect?.selectedOptions?.[0];
              const itemImage = item.querySelector('[data-bundle-item-image]');
              const itemPrice = item.querySelector('[data-bundle-item-price]');
              const comparePrice = item.querySelector('[data-bundle-compare-price]');
              const itemToggle = item.querySelector('[data-bundle-item-toggle]');
              const customValue = item.querySelector('[data-bundle-custom-value]');
              const customOptions = item.querySelectorAll('[data-bundle-custom-option]');
              const variantAvailable = selectedOption?.dataset.available === 'true';
              const price = Number(selectedOption?.dataset.price || 0);
              const compareAtPrice = Number(selectedOption?.dataset.comparePrice || 0);

              item.dataset.variantId = selectedOption?.value || '';
              item.dataset.variantPrice = String(price);
              item.dataset.variantAvailable = variantAvailable ? 'true' : 'false';
              item.classList.toggle('is-unavailable', !variantAvailable);

              if (itemPrice) itemPrice.textContent = formatMoney(price);

              if (comparePrice) {
                const hasComparePrice = compareAtPrice > price;
                comparePrice.textContent = hasComparePrice ? formatMoney(compareAtPrice) : '';
                comparePrice.hidden = !hasComparePrice;
              }

              if (itemImage && selectedOption?.dataset.imageUrl) {
                itemImage.src = selectedOption.dataset.imageUrl;
                itemImage.alt = selectedOption.dataset.imageAlt || itemImage.alt;
              }

              if (customValue && selectedOption) {
                customValue.textContent = selectedOption.textContent.trim();
              }

              customOptions.forEach((option) => {
                const isSelected = option.dataset.variantValue === selectedOption?.value;
                option.classList.toggle('is-selected', isSelected);
                option.setAttribute('aria-selected', isSelected ? 'true' : 'false');
              });

              if (itemToggle) {
                itemToggle.disabled = !variantAvailable;
                if (!variantAvailable) itemToggle.checked = false;
                item.classList.toggle('is-unselected', !itemToggle.checked);
              }
            };

            /**
             * 判断商品行是否计入当前捆绑。
             * 主产品始终计入，可选商品由复选框控制。
             * @param {HTMLElement} item 商品行节点。
             * @returns {boolean}
             */
            const isItemSelected = (item) => {
              if (item.dataset.required === 'true') return true;
              return item.querySelector('[data-bundle-item-toggle]')?.checked === true;
            };

            /**
             * 聚合相同变体，生成 Shopify Ajax Cart API 所需的 items 数组。
             * @returns {Array<{id: number, quantity: number}>}
             */
            const buildSelectedItems = () => {
              const selectedVariants = new Map();

              for (const item of items) {
                if (!isItemSelected(item) || item.dataset.variantAvailable !== 'true') continue;

                const variantId = Number(item.dataset.variantId || 0);
                if (!Number.isInteger(variantId) || variantId <= 0) continue;

                selectedVariants.set(variantId, (selectedVariants.get(variantId) || 0) + 1);
              }

              return Array.from(selectedVariants, ([id, quantity]) => ({ id, quantity }));
            };

            /**
             * 重新计算总价，并阻止缺货或缺少主产品时提交。
             */
            const updateBundleState = () => {
              let totalPrice = 0;
              let selectedCount = 0;
              const requiredItems = items.filter((item) => item.dataset.required === 'true');
              const requiredItemsAvailable = requiredItems.length > 0
                && requiredItems.every((item) => item.dataset.variantAvailable === 'true');

              for (const item of items) {
                const selected = isItemSelected(item);
                item.classList.toggle('is-unselected', !selected);

                if (!selected) continue;

                selectedCount += 1;
                if (item.dataset.variantAvailable === 'true') {
                  totalPrice += Number(item.dataset.variantPrice || 0);
                }
              }

              if (totalOutput) totalOutput.textContent = formatMoney(totalPrice);

              if (submitButton) {
                const isBusy = submitButton.dataset.loading === 'true';
                submitButton.disabled = isBusy || !requiredItemsAvailable || selectedCount === 0;
                submitButton.setAttribute('aria-busy', isBusy ? 'true' : 'false');
              }

              if (buttonLabel && submitButton?.dataset.loading !== 'true') {
                buttonLabel.textContent = submitButton.dataset.defaultLabel || 'Add Bundle to Cart';
              }
            };

            /**
             * 使用 Ajax Cart 返回的 section HTML 刷新主题迷你购物车。
             * @param {object} responseState Shopify 加购响应。
             * @param {HTMLElement|null} cartComponent 主题购物车组件。
             */
            const refreshCartSections = (responseState, cartComponent) => {
              if (!cartComponent || !responseState?.sections || typeof cartComponent.getSectionsToRender !== 'function') return;

              for (const sectionToRender of cartComponent.getSectionsToRender()) {
                const replacementTarget = document.getElementById(sectionToRender.id);
                const sectionHtml = responseState.sections[sectionToRender.id];
                if (!replacementTarget || !sectionHtml) continue;

                const parsedHtml = new DOMParser().parseFromString(sectionHtml, 'text/html');
                const replacementSource = parsedHtml.querySelector(`#${sectionToRender.id}`);
                if (!replacementSource) continue;

                replacementTarget.innerHTML = replacementSource.innerHTML;
              }

              cartComponent.cartAction?.();
            };

            /**
             * 拉取最新购物车摘要，更新页头数量、总价和免邮进度。
             */
            const refreshCartSummary = async () => {
              const cartRoute = window.routes?.cart_url || '/cart';
              const cartJsonUrl = cartRoute.endsWith('.js') ? cartRoute : `${cartRoute}.js`;
              const cartResponse = await fetch(cartJsonUrl, {
                headers: { Accept: 'application/json' },
                signal: eventController.signal
              });

              if (!cartResponse.ok) return;

              const cartState = await cartResponse.json();
              document.querySelectorAll('.cart-count').forEach((countElement) => {
                countElement.textContent = countElement.classList.contains('cart-count-drawer')
                  ? `(${cartState.item_count})`
                  : cartState.item_count > 100 ? '~' : String(cartState.item_count);
              });

              document.querySelector('header-total-price')?.updateTotal?.(cartState);
              document.querySelector('free-ship-progress-bar')?.init?.(cartState.items_subtotal_price);
            };

            /**
             * 一次请求提交所有已选变体，成功后刷新并打开主题购物车。
             */
            const addBundleToCart = async () => {
              if (!submitButton || submitButton.disabled) return;

              const selectedItems = buildSelectedItems();
              if (selectedItems.length === 0) return;

              const cartComponent = document.querySelector('cart-notification')
                || document.querySelector('cart-drawer');
              const sectionIds = typeof cartComponent?.getSectionsToRender === 'function'
                ? cartComponent.getSectionsToRender().map((sectionToRender) => sectionToRender.id)
                : [];
              const requestBody = { items: selectedItems };

              if (sectionIds.length > 0) {
                requestBody.sections = sectionIds;
                requestBody.sections_url = window.location.pathname;
              }

              window.clearTimeout(successResetTimer);
              submitButton.dataset.loading = 'true';
              submitButton.disabled = true;
              submitButton.setAttribute('aria-busy', 'true');
              if (buttonLabel) buttonLabel.textContent = submitButton.dataset.loadingLabel || 'Adding bundle...';
              if (statusOutput) statusOutput.textContent = '';

              let requestSucceeded = false;

              try {
                const cartAddRoute = window.routes?.cart_add_url || '/cart/add';
                const cartAddUrl = cartAddRoute.endsWith('.js') ? cartAddRoute : `${cartAddRoute}.js`;
                const response = await fetch(cartAddUrl, {
                  method: 'POST',
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                  },
                  body: JSON.stringify(requestBody),
                  signal: eventController.signal
                });
                const responseState = await response.json().catch(() => ({}));

                if (!response.ok) {
                  throw new Error(responseState.description || responseState.message || offer.dataset.errorLabel);
                }

                requestSucceeded = true;
                try {
                  refreshCartSections(responseState, cartComponent);
                  await refreshCartSummary();
                  cartComponent?.open?.();
                } catch (cartRefreshError) {
                  // 商品已经加入购物车；此处只记录主题购物车 UI 刷新失败，避免误导顾客重复加购。
                  console.error('Bundle offer cart refresh error:', cartRefreshError);
                }

                if (buttonLabel) buttonLabel.textContent = submitButton.dataset.successLabel || 'Bundle added';
                if (statusOutput) statusOutput.textContent = submitButton.dataset.successLabel || 'Bundle added';

                offer.dispatchEvent(new CustomEvent('bundle-offer:added', {
                  bubbles: true,
                  detail: { response: responseState, items: selectedItems }
                }));

                successResetTimer = window.setTimeout(() => {
                  submitButton.dataset.loading = 'false';
                  updateBundleState();
                }, 1800);
              } catch (error) {
                if (error.name === 'AbortError') return;

                const errorMessage = error.message || offer.dataset.errorLabel || 'Unable to add this bundle. Please try again.';
                if (statusOutput) statusOutput.textContent = errorMessage;

                offer.dispatchEvent(new CustomEvent('bundle-offer:error', {
                  bubbles: true,
                  detail: { error }
                }));

                console.error('Bundle offer add-to-cart error:', error);
              } finally {
                if (!requestSucceeded) {
                  submitButton.dataset.loading = 'false';
                  updateBundleState();
                }
              }
            };

            for (const item of items) {
              initializeCustomSelect(item);
              updateItemVariant(item);

              item.querySelector('[data-bundle-variant-select]')?.addEventListener('change', () => {
                updateItemVariant(item);
                updateBundleState();
              }, { signal: eventController.signal });

              item.querySelector('[data-bundle-item-toggle]')?.addEventListener('change', () => {
                updateBundleState();
              }, { signal: eventController.signal });
            }

            document.addEventListener('click', (event) => {
              const eventTarget = event.target instanceof Element ? event.target : null;
              if (!eventTarget?.closest('[data-bundle-custom-select]')) {
                closeAllCustomSelects();
              }
            }, { signal: eventController.signal });

            submitButton?.addEventListener('click', addBundleToCart, { signal: eventController.signal });

            offer.bundleOfferCleanup = () => {
              window.clearTimeout(successResetTimer);
              eventController.abort();
              delete offer.dataset.bundleOfferReady;
            };

            offer.dataset.bundleOfferReady = 'true';
            updateBundleState();
          });
        };

        const getCurrentQuantity = () => {
          const input = section.querySelector('[data-zl-ear-seed-quantity-input]');
          const display = section.querySelector('[data-zl-ear-seed-quantity-display]');

          return Number(input?.value || display?.value || 1);
        };

        const updateLinePrice = (quantityValue, unitPrice) => {
          const linePrice = section.querySelector('[data-zl-ear-seed-line-price]');
          if (!linePrice) return;

          const currentUnitPrice = Number(unitPrice !== undefined ? unitPrice : linePrice.dataset.unitPrice || 0);
          const currentQuantity = Math.max(Number(quantityValue || 1), 1);

          linePrice.dataset.unitPrice = String(currentUnitPrice);
          linePrice.textContent = formatMoney(currentUnitPrice * currentQuantity);
        };

        const bindLinePrice = () => {
          if (section.dataset.zlEarSeedLinePriceReady === 'true') {
            updateLinePrice(getCurrentQuantity());
            return;
          }

          const syncLinePrice = (unitPrice) => {
            window.setTimeout(() => {
              updateLinePrice(getCurrentQuantity(), unitPrice);
            }, 0);
          };

          section.addEventListener('input', (event) => {
            const target = event.target instanceof Element ? event.target : event.target?.parentElement;
            if (target?.closest('[data-zl-ear-seed-quantity-display], [data-zl-ear-seed-quantity-input]')) {
              syncLinePrice();
            }
          });

          section.addEventListener('change', (event) => {
            const target = event.target instanceof Element ? event.target : event.target?.parentElement;
            if (target?.closest('[data-zl-ear-seed-quantity-display], [data-zl-ear-seed-quantity-input]')) {
              syncLinePrice();
            }
          });

          section.addEventListener('click', (event) => {
            const target = event.target instanceof Element ? event.target : event.target?.parentElement;
            const quantityButton = target?.closest('[data-zl-ear-seed-quantity-button]');
            const variantButton = target?.closest('[data-zl-ear-seed-variant-button]');

            if (quantityButton && section.contains(quantityButton)) {
              syncLinePrice();
              return;
            }

            if (variantButton && section.contains(variantButton)) {
              syncLinePrice(variantButton.dataset.variantPriceCents);
            }
          });

          section.dataset.zlEarSeedLinePriceReady = 'true';
          updateLinePrice(getCurrentQuantity());
        };

        bindLinePrice();
        initBundleOffers();

        if (section.dataset.zlEarSeedReady === 'true') return;

        let buttons = [];
        let slides = [];
        let dots = [];
        let image = null;
        let moreMediaButton = null;
        let thumbsContainer = null;
        const autoplayDelay = 3500;
        const reduceMotion = window.matchMedia
          ? window.matchMedia('(prefers-reduced-motion: reduce)')
          : { matches: false };
        const mobileThumbQuery = window.matchMedia
          ? window.matchMedia('(max-width: 640px)')
          : { matches: false };
        let autoplayTimer = 0;
        let isAutoplayPaused = false;
        let imageTransitionToken = 0;
        const variantJson = section.querySelector('[data-zl-ear-seed-variant-json]');
        let variantData = [];

        if (variantJson) {
          try {
            variantData = JSON.parse(variantJson.textContent || '[]');
          } catch (error) {
            variantData = [];
          }
        }

        const refreshMediaElements = () => {
          buttons = Array.from(section.querySelectorAll('[data-zl-ear-seed-thumb]'));
          slides = Array.from(section.querySelectorAll('[data-zl-ear-seed-slide]')).map((slide) => ({
            src: slide.dataset.fullSrc,
            alt: slide.dataset.alt || '',
            imageId: slide.dataset.imageId || '',
          })).filter((slide) => slide.src);
          dots = Array.from(section.querySelectorAll('[data-zl-ear-seed-slide-dot]'));
          image = section.querySelector('[data-zl-ear-seed-main-image]');
          moreMediaButton = section.querySelector('[data-zl-ear-seed-more-media]');
          thumbsContainer = section.querySelector('[data-zl-ear-seed-thumbs]');
        };

        const normalizeSlideIndex = (index) => {
          if (!slides.length) return 0;
          return (index + slides.length) % slides.length;
        };

        const getSlideDirection = (nextIndex, previousIndex) => {
          if (slides.length <= 1) return 0;

          const normalizedPreviousIndex = normalizeSlideIndex(previousIndex);
          if (nextIndex === normalizedPreviousIndex) return 0;

          const forwardDistance = (nextIndex - normalizedPreviousIndex + slides.length) % slides.length;
          const backwardDistance = (normalizedPreviousIndex - nextIndex + slides.length) % slides.length;

          return forwardDistance <= backwardDistance ? 1 : -1;
        };

        const getSlideIndex = (element) => {
          const parsedIndex = Number(element?.dataset.slideIndex || 0);
          return Number.isFinite(parsedIndex) ? parsedIndex : 0;
        };

        const getEventElement = (event) => {
          const target = event.target;
          return target instanceof Element ? target : target?.parentElement || null;
        };

        const getVisibleThumbLimit = () => {
          if (mobileThumbQuery.matches) {
            return Math.min(3, buttons.length);
          }
          return Math.min(7, buttons.length);
        };

        const canAnimate = () => {
          return !reduceMotion.matches && typeof Element !== 'undefined' && typeof Element.prototype.animate === 'function';
        };

        const animateThumbnailWindow = (previousRects, direction) => {
          if (!previousRects || !canAnimate()) return;

          const travel = direction < 0 ? -16 : 16;
          const visibleButtons = buttons.filter((button) => !button.hidden);

          visibleButtons.forEach((button, index) => {
            const previousRect = previousRects.get(button);
            const nextRect = button.getBoundingClientRect();
            const delay = Math.min(index * 18, 90);
            const keyframes = previousRect
              ? [
                  {
                    opacity: 1,
                    transform: `translate3d(${previousRect.left - nextRect.left}px, ${previousRect.top - nextRect.top}px, 0)`,
                  },
                  { opacity: 1, transform: 'translate3d(0, 0, 0)' },
                ]
              : [
                  { opacity: 0, transform: `translate3d(0, ${travel}px, 0)` },
                  { opacity: 1, transform: 'translate3d(0, 0, 0)' },
                ];

            button.getAnimations?.().forEach((animation) => animation.cancel());
            button.animate(keyframes, {
              duration: 280,
              delay,
              easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
            });
          });

          if (moreMediaButton) {
            moreMediaButton.classList.add('is-window-animating');
            window.setTimeout(() => moreMediaButton.classList.remove('is-window-animating'), 260);
          }
        };

        const applyFeaturedImage = (slide) => {
          if (!image || !slide?.src) return;

          image.src = slide.src;
          image.removeAttribute('srcset');
          image.alt = slide.alt || '';
        };

        const transitionFeaturedImage = (slide, direction = 0) => {
          if (!image || !slide?.src) return;

          const currentSrc = image.currentSrc || image.src || '';
          const currentAttributeSrc = image.getAttribute('src') || '';
          const isSameImage = currentSrc === slide.src || currentAttributeSrc === slide.src;

          if (!canAnimate() || isSameImage) {
            applyFeaturedImage(slide);
            return;
          }

          const token = ++imageTransitionToken;
          const travel = direction < 0 ? -22 : 22;

          image.getAnimations?.().forEach((animation) => animation.cancel());

          const preload = new window.Image();
          const preloadImage = new Promise((resolve) => {
            preload.onload = resolve;
            preload.onerror = resolve;
            preload.src = slide.src;
          });

          const exitAnimation = image.animate(
            [
              { opacity: 1, transform: 'translate3d(0, 0, 0) scale(1)' },
              { opacity: 0, transform: `translate3d(${-travel}px, 0, 0) scale(0.985)` },
            ],
            {
              duration: 170,
              easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
              fill: 'forwards',
            }
          );

          Promise.all([exitAnimation.finished.catch(() => {}), preloadImage]).then(() => {
            if (token !== imageTransitionToken) return;

            exitAnimation.cancel();
            applyFeaturedImage(slide);

            const enterAnimation = image.animate(
              [
                { opacity: 0, transform: `translate3d(${travel}px, 0, 0) scale(0.985)` },
                { opacity: 1, transform: 'translate3d(0, 0, 0) scale(1)' },
              ],
              {
                duration: 280,
                easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
                fill: 'forwards',
              }
            );

            enterAnimation.finished
              .catch(() => {})
              .finally(() => {
                if (token !== imageTransitionToken) return;
                enterAnimation.cancel();
                image.style.opacity = '';
                image.style.transform = '';
              });
          });
        };

        const updateMoreMediaButtonState = () => {
          if (!moreMediaButton || !thumbsContainer) return;

          const parsedVisibleThumbLimit = Number(moreMediaButton.dataset.visibleThumbLimit || 0);
          const visibleThumbLimit = Number.isFinite(parsedVisibleThumbLimit) && parsedVisibleThumbLimit > 0
            ? parsedVisibleThumbLimit
            : getVisibleThumbLimit();
          const maxStartIndex = Math.max(buttons.length - visibleThumbLimit, 0);
          const parsedStartIndex = Number(moreMediaButton.dataset.thumbWindowStart || 0);
          const currentStartIndex = Math.min(Math.max(Number.isFinite(parsedStartIndex) ? parsedStartIndex : 0, 0), maxStartIndex);
          const remainingBelowCount = Math.max(buttons.length - (currentStartIndex + visibleThumbLimit), 0);

          moreMediaButton.dataset.thumbWindowStart = String(currentStartIndex);

          if (buttons.length <= visibleThumbLimit) {
            moreMediaButton.hidden = true;
            return;
          }

          moreMediaButton.hidden = false;
          moreMediaButton.setAttribute('aria-expanded', 'false');

          if (remainingBelowCount > 0) {
            moreMediaButton.textContent = `+${remainingBelowCount}`;
            moreMediaButton.setAttribute('aria-label', `Show next ${remainingBelowCount} product images`);
          } else {
            moreMediaButton.textContent = 'Top';
            moreMediaButton.setAttribute('aria-label', 'Show first product images');
          }
        };

        const updateThumbnailWindow = (startIndex = 0, options = {}) => {
          refreshMediaElements();

          const visibleThumbLimit = getVisibleThumbLimit();
          const maxStartIndex = Math.max(buttons.length - visibleThumbLimit, 0);
          const normalizedStartIndex = Math.min(Math.max(Number(startIndex) || 0, 0), maxStartIndex);
          const previousStartIndex = Number(moreMediaButton?.dataset.thumbWindowStart || 0);
          const shouldAnimate = options.animate && canAnimate();
          const previousRects = shouldAnimate ? new Map() : null;

          if (previousRects) {
            buttons.forEach((button) => {
              if (!button.hidden) previousRects.set(button, button.getBoundingClientRect());
            });
          }

          buttons.forEach((button) => {
            const slideIndex = getSlideIndex(button);
            const isVisible = slideIndex >= normalizedStartIndex && slideIndex < normalizedStartIndex + visibleThumbLimit;
            button.hidden = !isVisible;
            button.classList.toggle('is-thumb-window-hidden', !isVisible);
            button.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
            button.tabIndex = isVisible ? 0 : -1;
          });

          if (moreMediaButton) {
            moreMediaButton.dataset.thumbWindowStart = String(normalizedStartIndex);
            moreMediaButton.dataset.visibleThumbLimit = String(visibleThumbLimit);
          }

          updateMoreMediaButtonState();

          if (previousRects) {
            const direction = normalizedStartIndex < previousStartIndex ? -1 : 1;
            window.requestAnimationFrame(() => animateThumbnailWindow(previousRects, direction));
          }
        };

        const scrollThumbnailWindow = (button) => {
          refreshMediaElements();

          const visibleThumbLimit = getVisibleThumbLimit();
          const maxStartIndex = Math.max(buttons.length - visibleThumbLimit, 0);
          const parsedStartIndex = Number(button?.dataset.thumbWindowStart || moreMediaButton?.dataset.thumbWindowStart || 0);
          const currentStartIndex = Math.min(Math.max(Number.isFinite(parsedStartIndex) ? parsedStartIndex : 0, 0), maxStartIndex);
          const nextStartIndex = currentStartIndex >= maxStartIndex
            ? 0
            : Math.min(currentStartIndex + 1, maxStartIndex);

          updateThumbnailWindow(nextStartIndex, { animate: true });
        };

        const revealThumbnailForSlide = (index) => {
          refreshMediaElements();

          if (!buttons.length) return;

          const slideIndex = normalizeSlideIndex(index);
          const visibleThumbLimit = getVisibleThumbLimit();
          const currentStartIndex = Number(moreMediaButton?.dataset.thumbWindowStart || 0);
          const maxStartIndex = Math.max(buttons.length - visibleThumbLimit, 0);
          const isVisible = slideIndex >= currentStartIndex && slideIndex < currentStartIndex + visibleThumbLimit;

          if (isVisible) return;

          const nextStartIndex = slideIndex < currentStartIndex
            ? slideIndex
            : Math.min(Math.max(slideIndex - visibleThumbLimit + 1, 0), maxStartIndex);

          updateThumbnailWindow(nextStartIndex, { animate: true });
        };

        const activateSlide = (index, options = {}) => {
          refreshMediaElements();

          if (!image || !slides.length) return;

          const slideIndex = normalizeSlideIndex(index);
          const slide = slides[slideIndex];
          const previousIndex = Number(section.dataset.zlEarSeedActiveIndex || 0);

          transitionFeaturedImage(slide, getSlideDirection(slideIndex, previousIndex));
          section.dataset.zlEarSeedActiveIndex = String(slideIndex);

          buttons.forEach((item) => {
            const isActive = getSlideIndex(item) === slideIndex;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-current', isActive ? 'true' : 'false');
          });

          dots.forEach((dot) => {
            dot.classList.toggle('is-active', getSlideIndex(dot) === slideIndex);
          });

          if (options.revealThumbnail !== false) {
            revealThumbnailForSlide(slideIndex);
          }
        };

        const activateVariantImage = (imageId, imageSrc, imageAlt, slideIndex) => {
          refreshMediaElements();

          let matchingSlideIndex = -1;
          const parsedSlideIndex = Number(slideIndex);

          if (imageId) {
            matchingSlideIndex = slides.findIndex((slide) => slide.imageId === imageId);
          }

          if (
            matchingSlideIndex < 0
            && Number.isInteger(parsedSlideIndex)
            && parsedSlideIndex >= 0
            && parsedSlideIndex < slides.length
          ) {
            matchingSlideIndex = parsedSlideIndex;
          }

          if (matchingSlideIndex < 0 && imageSrc) {
            matchingSlideIndex = slides.findIndex((slide) => slide.src === imageSrc);
          }

          if (matchingSlideIndex >= 0) {
            activateSlide(matchingSlideIndex, { revealThumbnail: true });
            return;
          }

          if (!image || !imageSrc) return;

          transitionFeaturedImage({ src: imageSrc, alt: imageAlt || image.alt }, 0);
        };

        const getSelectedOptionValues = () => {
          return Array.from(section.querySelectorAll('[data-zl-ear-seed-option-group]')).map((group) => {
            const activeButton = group.querySelector('[data-zl-ear-seed-variant-button].is-active');
            return activeButton?.dataset.optionValue || '';
          });
        };

        const findVariantByOptions = (selectedOptions) => {
          if (!selectedOptions.length || !variantData.length) return null;

          return variantData.find((variant) => {
            if (!Array.isArray(variant.options)) return false;

            return selectedOptions.every((optionValue, index) => {
              return variant.options[index] === optionValue;
            });
          }) || null;
        };

        const getVariantFeaturedImage = (variant) => {
          return variant?.featured_image || variant?.featured_media?.preview_image || null;
        };

        const getVariantImageId = (variant) => {
          const featuredImage = getVariantFeaturedImage(variant);
          return featuredImage?.id ? String(featuredImage.id) : '';
        };

        const getVariantImageSrc = (variant) => {
          const featuredImage = getVariantFeaturedImage(variant);
          return featuredImage?.src || featuredImage?.url || '';
        };

        const getVariantSlideIndex = (variant, sourceButton) => {
          const featuredImage = getVariantFeaturedImage(variant);
          const imagePosition = Number(featuredImage?.position || variant?.featured_media?.position || 0);

          // Prefer Shopify's image position, then fall back to the server-rendered gallery index.
          if (Number.isInteger(imagePosition) && imagePosition > 0) {
            return imagePosition - 1;
          }

          const buttonSlideIndex = Number(sourceButton?.dataset.variantSlideIndex);

          if (Number.isInteger(buttonSlideIndex) && buttonSlideIndex >= 0) {
            return buttonSlideIndex;
          }

          return -1;
        };

        const getVariantDiscount = (variant) => {
          const price = Number(variant?.price || 0);
          const compareAtPrice = Number(variant?.compare_at_price || 0);

          if (!compareAtPrice || compareAtPrice <= price) return '';

          return `-${Math.round(((compareAtPrice - price) * 100) / compareAtPrice)}%`;
        };

        const setSubmitState = (variant) => {
          const isAvailable = variant?.available === true;
          const variantInput = section.querySelector('[data-zl-ear-seed-variant-input]');
          const submitButton = section.querySelector('[data-zl-ear-seed-submit-button]');
          const submitLabel = submitButton?.querySelector('.btn-label');

          if (variantInput) {
            if (variant?.id) {
              variantInput.value = String(variant.id);
              variantInput.disabled = false;
              variantInput.dispatchEvent(new Event('change', { bubbles: true }));
            } else {
              variantInput.disabled = true;
            }
          }

          if (!submitButton) return;

          submitButton.disabled = !isAvailable;
          submitButton.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');

          if (submitLabel) {
            submitLabel.textContent = isAvailable
              ? submitButton.dataset.addLabel || 'Add to Cart'
              : submitButton.dataset.soldOutLabel || 'Sold out';
          }
        };

        const updateOptionButtonAvailability = () => {
          const selectedOptions = getSelectedOptionValues();

          section.querySelectorAll('[data-zl-ear-seed-variant-button]').forEach((optionButton) => {
            const optionPosition = Number(optionButton.dataset.optionPosition || 0);
            const nextOptions = selectedOptions.slice();
            nextOptions[optionPosition - 1] = optionButton.dataset.optionValue || '';
            const nextVariant = findVariantByOptions(nextOptions);
            const isAvailable = nextVariant?.available === true;

            optionButton.classList.toggle('is-unavailable', !isAvailable);
            optionButton.dataset.variantAvailable = isAvailable ? 'true' : 'false';
          });
        };

        const updateSelectedVariantContent = (variant, sourceButton) => {
          const price = section.querySelector('[data-zl-ear-seed-price]');
          const comparePrice = section.querySelector('[data-zl-ear-seed-compare-price]');
          const discount = section.querySelector('[data-zl-ear-seed-discount]');
          const variantPrice = Number(variant?.price || 0);
          const variantCompareAtPrice = Number(variant?.compare_at_price || 0);

          if (price && variant) {
            price.textContent = formatMoney(variantPrice);
          }

          if (discount) {
            const discountLabel = getVariantDiscount(variant);
            discount.textContent = discountLabel;
            discount.hidden = !discountLabel;
          }

          if (comparePrice) {
            const hasComparePrice = variantCompareAtPrice > variantPrice;
            comparePrice.textContent = hasComparePrice ? formatMoney(variantCompareAtPrice) : '';
            comparePrice.hidden = !hasComparePrice;
          }

          if (variant) {
            updateLinePrice(getCurrentQuantity(), variantPrice);
          }

          const imageId = getVariantImageId(variant) || sourceButton?.dataset.variantImageId || '';
          const imageSrc = getVariantImageSrc(variant) || sourceButton?.dataset.variantImageSrc || '';
          const imageAlt = variant?.title || sourceButton?.dataset.optionValue || '';
          const slideIndex = getVariantSlideIndex(variant, sourceButton);

          activateVariantImage(imageId, imageSrc, imageAlt, slideIndex);
        };

        const selectVariant = (button) => {
          if (!button) return;

          const optionValue = button.dataset.optionValue || '';
          const optionPosition = button.dataset.optionPosition || '';
          const optionGroup = button.closest('[data-zl-ear-seed-option-group]');
          const optionButtons = Array.from(optionGroup?.querySelectorAll('[data-zl-ear-seed-variant-button]') || []);
          const selectedValue = optionPosition
            ? section.querySelector(`[data-zl-ear-seed-selected-option-value][data-option-position="${optionPosition}"]`)
            : null;

          optionButtons.forEach((variantButton) => {
            const isActive = variantButton === button;
            variantButton.classList.toggle('is-active', isActive);
            variantButton.setAttribute('aria-checked', isActive ? 'true' : 'false');
          });

          if (selectedValue) selectedValue.textContent = optionValue;

          const currentVariant = findVariantByOptions(getSelectedOptionValues());

          setSubmitState(currentVariant);
          updateSelectedVariantContent(currentVariant, button);
          updateOptionButtonAvailability();
        };

        const stopAutoplay = () => {
          if (!autoplayTimer) return;

          window.clearTimeout(autoplayTimer);
          autoplayTimer = 0;
        };

        const startAutoplay = () => {
          stopAutoplay();

          if (slides.length <= 1 || isAutoplayPaused || reduceMotion.matches || document.hidden) return;

          autoplayTimer = window.setTimeout(() => {
            const currentIndex = Number(section.dataset.zlEarSeedActiveIndex || 0);
            activateSlide(currentIndex + 1);
            startAutoplay();
          }, autoplayDelay);
        };

        const restartAutoplay = () => {
          if (isAutoplayPaused) return;
          startAutoplay();
        };

        const pauseAutoplay = () => {
          isAutoplayPaused = true;
          stopAutoplay();
        };

        const resumeAutoplay = () => {
          isAutoplayPaused = false;
          startAutoplay();
        };

        const handleFocusOut = () => {
          window.setTimeout(() => {
            if (!section.contains(document.activeElement)) resumeAutoplay();
          }, 0);
        };

        const handleVisibilityChange = () => {
          if (document.hidden) {
            stopAutoplay();
            return;
          }

          restartAutoplay();
        };

        const handleMotionPreference = () => {
          if (reduceMotion.matches) {
            stopAutoplay();
            return;
          }

          restartAutoplay();
        };

        const handleThumbViewportChange = () => {
          refreshMediaElements();
          updateThumbnailWindow();
          const currentIndex = Number(section.dataset.zlEarSeedActiveIndex || 0);
          revealThumbnailForSlide(currentIndex);
        };

        const handleMoreMediaActivation = (event) => {
          const eventElement = getEventElement(event);
          const moreButton = eventElement?.closest('[data-zl-ear-seed-more-media]');

          if (!moreButton || !section.contains(moreButton)) return false;

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation?.();
          scrollThumbnailWindow(moreButton);
          restartAutoplay();
          return true;
        };

        section.addEventListener('click', (event) => {
          refreshMediaElements();

          const eventElement = getEventElement(event);
          const thumbButton = eventElement?.closest('[data-zl-ear-seed-thumb]');
          const moreButton = eventElement?.closest('[data-zl-ear-seed-more-media]');
          const carouselButton = eventElement?.closest('[data-zl-ear-seed-carousel-button]');
          const dotButton = eventElement?.closest('[data-zl-ear-seed-slide-dot]');
          const variantButton = eventElement?.closest('[data-zl-ear-seed-variant-button]');

          if (variantButton && section.contains(variantButton)) {
            event.preventDefault();
            selectVariant(variantButton);
            restartAutoplay();
            return;
          }

          if (thumbButton && section.contains(thumbButton)) {
            activateSlide(getSlideIndex(thumbButton));
            restartAutoplay();
            return;
          }

          if (moreButton && section.contains(moreButton)) {
            handleMoreMediaActivation(event);
            return;
          }

          if (carouselButton && section.contains(carouselButton)) {
            const currentIndex = Number(section.dataset.zlEarSeedActiveIndex || 0);
            const direction = carouselButton.dataset.direction === 'next' ? 1 : -1;
            activateSlide(currentIndex + direction);
            restartAutoplay();
            return;
          }

          if (dotButton && section.contains(dotButton)) {
            activateSlide(getSlideIndex(dotButton));
            restartAutoplay();
          }
        });

        section.addEventListener('keydown', (event) => {
          refreshMediaElements();

          if (!['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].includes(event.key)) return;

          const currentButton = event.target.closest('[data-zl-ear-seed-thumb]');
          if (!currentButton || !section.contains(currentButton)) return;

          event.preventDefault();

          const visibleButtons = buttons.filter((button) => !button.hidden);
          const currentIndex = visibleButtons.indexOf(currentButton);
          const direction = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
          const nextIndex = (currentIndex + direction + visibleButtons.length) % visibleButtons.length;
          const nextButton = visibleButtons[nextIndex];

          nextButton.focus();
          activateSlide(getSlideIndex(nextButton));
          restartAutoplay();
        });

        refreshMediaElements();

        const scheduleMoreMediaUpdate = () => {
          window.requestAnimationFrame(() => {
            updateMoreMediaButtonState();
          });
        };

        window.addEventListener('resize', scheduleMoreMediaUpdate, { passive: true });

        updateThumbnailWindow();
        activateSlide(0);
        startAutoplay();
        scheduleMoreMediaUpdate();

        section.addEventListener('mouseenter', pauseAutoplay);
        section.addEventListener('mouseleave', resumeAutoplay);
        section.addEventListener('focusin', pauseAutoplay);
        section.addEventListener('focusout', handleFocusOut);
        document.addEventListener('visibilitychange', handleVisibilityChange);

        if (reduceMotion.addEventListener) {
          reduceMotion.addEventListener('change', handleMotionPreference);
        } else if (reduceMotion.addListener) {
          reduceMotion.addListener(handleMotionPreference);
        }

        if (mobileThumbQuery.addEventListener) {
          mobileThumbQuery.addEventListener('change', handleThumbViewportChange);
        } else if (mobileThumbQuery.addListener) {
          mobileThumbQuery.addListener(handleThumbViewportChange);
        }

        updateOptionButtonAvailability();

        section.zlEarSeedHeroCleanup = () => {
          stopAutoplay();
          window.removeEventListener('resize', scheduleMoreMediaUpdate);
          document.removeEventListener('visibilitychange', handleVisibilityChange);

          if (reduceMotion.removeEventListener) {
            reduceMotion.removeEventListener('change', handleMotionPreference);
          } else if (reduceMotion.removeListener) {
            reduceMotion.removeListener(handleMotionPreference);
          }

          if (mobileThumbQuery.removeEventListener) {
            mobileThumbQuery.removeEventListener('change', handleThumbViewportChange);
          } else if (mobileThumbQuery.removeListener) {
            mobileThumbQuery.removeListener(handleThumbViewportChange);
          }

          section.querySelectorAll('[data-bundle-offer]').forEach((offer) => {
            offer.bundleOfferCleanup?.();
          });
        };

        section.querySelectorAll('[data-zl-ear-seed-quantity]').forEach((quantity) => {
          const input = quantity.querySelector('[data-zl-ear-seed-quantity-input]');
          const display = quantity.querySelector('[data-zl-ear-seed-quantity-display]');
          const minusButton = quantity.querySelector('[data-direction="minus"]');
          const plusButton = quantity.querySelector('[data-direction="plus"]');

          if (!input || !display) return;

          const form = input.form || quantity.closest('form');
          const sanitizeQuantityInput = (value) => String(value).replace(/[^\d]/g, '');
          const syncButtonState = (quantityValue) => {
            const min = Number(input.min || 1);
            const max = input.max ? Number(input.max) : Infinity;

            minusButton?.classList.toggle('disabled', quantityValue <= min);
            minusButton?.setAttribute('aria-disabled', quantityValue <= min ? 'true' : 'false');
            plusButton?.classList.toggle('disabled', quantityValue >= max);
            plusButton?.setAttribute('aria-disabled', quantityValue >= max ? 'true' : 'false');
          };

          const setQuantityValue = (quantityValue) => {
            input.value = String(quantityValue);
            display.value = String(quantityValue);
            syncButtonState(quantityValue);
            updateLinePrice(quantityValue);
          };

          const normalizeQuantity = (nextValue) => {
            const min = Number(input.min || 1);
            const max = input.max ? Number(input.max) : Infinity;
            const fallback = Number(input.value || display.value || min);
            const sanitizedValue = sanitizeQuantityInput(nextValue);
            const parsedValue = Number.isFinite(Number(sanitizedValue)) ? Number(sanitizedValue) : fallback;
            const quantityValue = Math.min(Math.max(parsedValue, min), max);

            setQuantityValue(quantityValue);
          };

          normalizeQuantity(input.value);

          display.addEventListener('input', () => {
            display.value = sanitizeQuantityInput(display.value);
            input.value = display.value || input.min || '1';
            const quantityValue = Number(input.value || input.min || 1);
            syncButtonState(quantityValue);
            updateLinePrice(quantityValue);
          });

          display.addEventListener('change', () => {
            normalizeQuantity(display.value);
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });

          display.addEventListener('blur', () => {
            normalizeQuantity(display.value);
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });

          display.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              display.blur();
            }
          });

          form?.addEventListener('submit', () => {
            normalizeQuantity(display.value || input.value);
          }, { capture: true });

          quantity.addEventListener('click', (event) => {
            const eventElement = event.target instanceof Element ? event.target : event.target?.parentElement;
            const button = eventElement?.closest('[data-zl-ear-seed-quantity-button]');
            if (!button || !quantity.contains(button)) return;

            event.preventDefault();

            const step = Number(input.step || 1);
            const currentValue = Number(input.value || display.value || input.min || 1);
            const direction = button.dataset.direction === 'plus' ? 1 : -1;

            normalizeQuantity(currentValue + step * direction);
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });

        section.dataset.zlEarSeedReady = 'true';
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initEarSeedHero());
    } else {
      initEarSeedHero();
    }

    document.addEventListener('shopify:section:load', (event) => initEarSeedHero(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const hero = event.target?.matches?.('[data-zl-ear-seed-hero]')
        ? event.target
        : event.target?.querySelector?.('[data-zl-ear-seed-hero]');

      hero?.zlEarSeedHeroCleanup?.();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
